var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlockchainDevelopment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    enableBackground: "new 0 0 2500 2500",
    viewBox: "0 0 2500 2500",
    id: "BlockchainDevelopment",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M991.77,2182.38c-5.22,0-10.43-1.35-15.08-4.05L758,2051.31c-0.93-0.54-1.24-1.74-0.7-2.67 c0.53-0.94,1.72-1.25,2.67-0.71l218.68,127.02c8.06,4.68,18.09,4.71,26.17,0.04l220.17-127.06c0.91-0.54,2.11-0.23,2.67,0.71 c0.53,0.93,0.21,2.12-0.72,2.66l-220.17,127.06C1002.14,2181.05,996.95,2182.38,991.77,2182.38z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1661.21,857.31c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l554.12-321.78 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-554.12,321.78C1661.88,857.23,1661.54,857.31,1661.21,857.31z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2177.63,528.68c-14.11,8.14-14.19,21.34-0.17,29.48c14.01,8.14,36.82,8.13,50.93,0 c14.11-8.14,14.17-21.33,0.16-29.47C2214.53,520.55,2191.73,520.55,2177.63,528.68z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M2202.88,566.17c-9.57,0-19.14-2.11-26.41-6.33c-7.37-4.28-11.43-10.1-11.42-16.37 c0.01-6.32,4.13-12.17,11.6-16.48v0c14.63-8.42,38.34-8.42,52.88,0.01c7.38,4.29,11.44,10.1,11.43,16.38 c-0.01,6.31-4.13,12.16-11.6,16.47C2222.04,564.06,2212.46,566.17,2202.88,566.17z M2178.6,530.37 c-6.22,3.59-9.65,8.25-9.66,13.11c-0.01,4.82,3.37,9.43,9.49,12.99c13.45,7.82,35.43,7.81,48.98,0 c6.21-3.59,9.64-8.24,9.65-13.1c0.01-4.82-3.37-9.44-9.5-13C2214.13,522.56,2192.15,522.56,2178.6,530.37L2178.6,530.37z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M2202.92,552.72c5.5,0,10.82-1.25,14.6-3.43c3.04-1.75,4.78-3.9,4.78-5.9c0-1.98-1.71-4.1-4.69-5.83 c-3.75-2.18-9.05-3.43-14.54-3.43c-5.49,0-10.81,1.25-14.59,3.43c-3.04,1.75-4.78,3.91-4.79,5.91c0,1.98,1.7,4.1,4.68,5.83 C2192.13,551.47,2197.43,552.72,2202.92,552.72z",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M2078.74,623.34c5.91,0,11.62-1.34,15.68-3.69c3.26-1.88,5.13-4.19,5.14-6.34c0-2.12-1.83-4.4-5.03-6.26 c-4.03-2.34-9.72-3.68-15.62-3.68c-5.9,0-11.61,1.34-15.67,3.68c-3.26,1.88-5.14,4.2-5.14,6.35c0,2.12,1.83,4.4,5.03,6.26 C2067.15,622,2072.84,623.34,2078.74,623.34z",
    className: "color373b42 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M463.7,2204.79c-0.34,0-0.67-0.08-0.98-0.26l-202.78-117.79c-2.24-1.3-3.57-3.62-3.56-6.21 c0-2.59,1.34-4.92,3.59-6.21l204.15-117.81c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L261.9,2077.69 c-1.03,0.59-1.64,1.66-1.64,2.84c-0.01,1.18,0.6,2.24,1.63,2.84l202.78,117.79c0.93,0.54,1.24,1.74,0.7,2.67 C465.02,2204.44,464.37,2204.79,463.7,2204.79z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1595.49,2219.77c-3.79,0-7.59-0.98-10.97-2.95l-195.72-113.68c-0.93-0.54-1.24-1.74-0.7-2.67 c0.53-0.94,1.73-1.25,2.67-0.71l195.71,113.68c5.55,3.22,12.44,3.22,17.99,0.03l197.04-113.71c0.91-0.54,2.11-0.22,2.67,0.71 c0.53,0.93,0.21,2.12-0.72,2.66l-197.04,113.71C1603.04,2218.8,1599.27,2219.77,1595.49,2219.77z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1997.58,1969.47c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l215.83-124.55 c3.28-1.9,5.25-5.29,5.25-9.08c0.01-3.79-1.95-7.19-5.23-9.09l-214.34-124.5c-0.93-0.54-1.24-1.74-0.7-2.67 c0.53-0.94,1.72-1.25,2.67-0.71l214.34,124.5c4.49,2.61,7.17,7.28,7.17,12.47c-0.01,5.19-2.7,9.85-7.2,12.45l-215.83,124.55 C1998.25,1969.38,1997.92,1969.47,1997.58,1969.47z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1402.12,881.08c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03l273.6-157.92 c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L1402.12,881.08z",
    fill: "#000000",
    className: "color000000 svgShape"
  })))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1654.47,1647.03c-11.04,6.37-11.1,16.68-0.17,23.03L1926.16,1828c10.92,6.35,28.72,6.35,39.76-0.03l273.6-157.92 c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L1654.47,1647.03z",
    fill: "#000000",
    className: "color000000 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M976.91,2063.32c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03l273.6-157.92 c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L976.91,2063.32z",
    fill: "#000000",
    className: "color000000 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1032.6,1553.45c-0.34,0-0.67-0.08-0.98-0.26l-206.16-119.77c-0.93-0.54-1.24-1.74-0.7-2.67 c0.53-0.94,1.72-1.25,2.67-0.71l206.16,119.77c0.93,0.54,1.24,1.74,0.7,2.67C1033.92,1553.11,1033.27,1553.45,1032.6,1553.45z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1064.34,1917.67c-0.34,0-0.67-0.08-0.98-0.26l-308.87-179.48c-4.88-2.84-7.8-7.91-7.8-13.56 c0-5.65,2.92-10.71,7.8-13.55l655.02-380.5c0.61-0.35,1.36-0.35,1.96,0l331.41,192.52c0.93,0.54,1.24,1.74,0.7,2.67 c-0.54,0.93-1.73,1.24-2.67,0.71l-330.43-191.95l-654.03,379.93c-3.67,2.13-5.86,5.93-5.86,10.18 c0,4.24,2.19,8.05,5.86,10.18l308.87,179.48c0.93,0.54,1.24,1.74,0.7,2.67 C1065.67,1917.32,1065.01,1917.67,1064.34,1917.67z",
    className: "colordbdee4 svgShape"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1654.3,1317.21l271.86,157.95c5.7,3.31,13.3,4.84,20.84,4.69v313.87 c-7.45,0.12-14.95-1.44-20.62-4.75l-271.86-157.95c-5.41-3.09-8.15-7.24-8.15-11.38l-0.21-313.8 C1646.15,1309.97,1648.89,1314.05,1654.3,1317.21z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1946.22,1795.68c-7.89,0-15.25-1.77-20.83-5.03l-271.86-157.95c-5.79-3.31-9.12-8.08-9.12-13.07 l-0.21-313.81l0,0c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95c0,3.54,2.55,6.99,7.19,9.7l271.86,157.95 c5.09,2.97,12.29,4.61,19.81,4.42c0.38-0.03,1.02,0.19,1.4,0.56c0.37,0.37,0.59,0.87,0.59,1.39v313.87 c0,1.07-0.85,1.93-1.92,1.95C1946.75,1795.68,1946.49,1795.68,1946.22,1795.68z M1648.11,1314.84l0.2,304.79 c0,3.55,2.61,7.09,7.17,9.69l271.87,157.96c4.72,2.75,10.94,4.32,17.7,4.48v-309.96c-7.55-0.13-14.54-1.87-19.87-4.95 l-271.86-157.95c0,0,0,0,0,0C1651.25,1317.68,1649.5,1316.32,1648.11,1314.84z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1965.94,1475.17l273.55-157.95c5.62-3.23,8.36-7.38,8.36-11.59l0.21,313.8 c0,4.22-2.74,8.43-8.29,11.59l-273.62,157.95c-5.32,3.08-12.22,4.65-19.16,4.75v-313.87 C1953.86,1479.71,1960.68,1478.18,1965.94,1475.17z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1947,1795.67c-0.51,0-1.01-0.2-1.37-0.56c-0.37-0.37-0.58-0.87-0.58-1.39v-313.87 c0-1.06,0.85-1.93,1.91-1.95c6.88-0.14,13.28-1.71,18.02-4.43l273.54-157.95c4.77-2.74,7.39-6.26,7.39-9.91 c0-1.08,0.88-1.95,1.95-1.95s1.95,0.87,1.95,1.95l0.21,313.8c0,5.16-3.3,9.88-9.27,13.29l-273.61,157.95 c-5.38,3.11-12.51,4.9-20.1,5.02C1947.02,1795.67,1947,1795.67,1947,1795.67z M1948.95,1481.73v309.98 c6.18-0.35,11.89-1.9,16.23-4.42l273.62-157.95c4.72-2.69,7.32-6.21,7.32-9.91l-0.21-304.73 c-1.45,1.54-3.27,2.96-5.44,4.21l-273.55,157.95c0,0,0,0-0.01,0C1962.07,1479.63,1955.75,1481.34,1948.95,1481.73z  M1965.94,1475.17h0.05H1965.94z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1985.99 1508.61 2208.91 1379.9 2209.06 1603.73 1985.99 1732.5",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1985.99,1734.45c-0.34,0-0.67-0.09-0.97-0.26c-0.6-0.35-0.97-0.99-0.97-1.69v-223.88 c0-0.7,0.37-1.34,0.97-1.69l222.92-128.72c0.61-0.35,1.34-0.35,1.95,0c0.6,0.35,0.97,0.99,0.97,1.69l0.15,223.83 c0,0.7-0.37,1.34-0.97,1.69l-223.07,128.77C1986.66,1734.36,1986.33,1734.45,1985.99,1734.45z M1987.94,1509.74v219.38 l219.17-126.51l-0.15-219.33L1987.94,1509.74z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1654.47,1294.2c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03 l273.6-157.92c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L1654.47,1294.2z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1945.98,1481.83c-7.55,0-15.08-1.66-20.8-4.98l-271.86-157.95c-5.89-3.42-9.12-8.09-9.11-13.14 c0-5.09,3.3-9.8,9.3-13.26l273.59-157.92c11.55-6.67,30.28-6.67,41.72-0.02l271.86,157.94c5.89,3.42,9.12,8.09,9.11,13.14 c-0.01,5.09-3.31,9.8-9.3,13.26l-273.59,157.92C1961.11,1480.17,1953.54,1481.83,1945.98,1481.83z M1655.45,1295.88 L1655.45,1295.88c-4.74,2.73-7.35,6.25-7.35,9.9c-0.01,3.6,2.54,7.07,7.18,9.76l271.86,157.95 c10.37,6.02,27.33,6.02,37.81-0.03l273.59-157.92c4.74-2.73,7.34-6.24,7.35-9.89c0.01-3.6-2.54-7.07-7.18-9.76 l-271.86-157.94c-10.37-6.03-27.33-6.02-37.81,0.02L1655.45,1295.88z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1771.92 1345.82 2016.98 1204.38 2114.8 1261.23 1869.74 1402.6",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.68-0.09-0.98-0.26l-97.82-56.77c-0.6-0.35-0.97-0.99-0.97-1.69 c0-0.69,0.37-1.34,0.97-1.68l245.06-141.44c0.61-0.35,1.35-0.35,1.96,0l97.83,56.85c0.6,0.35,0.97,0.99,0.97,1.69 c0,0.7-0.37,1.34-0.97,1.69l-245.07,141.36C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M1775.81,1345.83 l93.93,54.52l241.18-139.12l-93.93-54.59L1775.81,1345.83z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2068,1061.6c-25.48-14.8-60.67-12.7-99.58,9.71c-77.26,44.64-139.71,152.85-139.46,241.56 c0.08,44.16,15.69,75.13,40.77,89.77l-56.95-33.16c-25.16-14.56-40.69-45.61-40.85-89.69 c-0.24-88.8,62.21-197,139.46-241.57c38.91-22.48,74.1-24.5,99.58-9.7L2068,1061.6z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.72,1404.58c-0.33,0-0.67-0.08-0.98-0.27l-56.95-33.16 c-26.81-15.51-41.66-47.96-41.82-91.36c-0.24-89.33,62.75-198.45,140.44-243.26c38.22-22.09,74.29-25.53,101.54-9.7 l56.93,33.02c0.04,0.02,0.07,0.04,0.11,0.06c0.93,0.54,1.24,1.73,0.7,2.67c-0.54,0.93-1.75,1.24-2.66,0.71l-0.07-0.04 c-25.93-15.02-60.58-11.55-97.57,9.75c-76.6,44.26-138.73,151.87-138.49,239.87c0.07,41.86,14.21,73.15,39.8,88.09 c0.93,0.54,1.24,1.74,0.7,2.67C1871.05,1404.24,1870.39,1404.58,1869.72,1404.58z M1974.09,1020.94 c-18.91,0-39.92,6.37-61.73,18.97c-76.6,44.19-138.73,151.8-138.49,239.88c0.15,41.95,14.32,73.21,39.88,88 l37.01,21.55c-15.4-17.77-23.7-44.09-23.75-76.47c-0.24-89.24,62.75-198.37,140.44-243.25 c28.7-16.52,56.14-22.59,79.53-17.96l-36.98-21.45C1999.33,1024.02,1987.22,1020.94,1974.09,1020.94z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2108.8,1151.36c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48 C2045.7,1026.76,2108.57,1062.55,2108.8,1151.36z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.67-0.09-0.97-0.26l-0.47-0.27c-0.4-0.22-0.75-0.42-1.12-0.66 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.15-2.75-0.24-5.59-0.24-8.44c-0.23-89.27,62.77-198.36,140.44-243.17 c38.16-22.02,74.14-25.53,101.3-9.88c26.98,15.53,41.9,48.05,42.02,91.57l0,0c0.08,29.7-6.85,62.74-20.03,95.55 c-5.96,14.66-12.85,28.77-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.82,114.7 C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M2031.19,1054.07c-18.91,0-39.95,6.37-61.81,18.98 c-76.59,44.19-138.72,151.76-138.49,239.79c0,2.78,0.08,5.55,0.24,8.24c1.77,36.87,15.32,64.91,38.15,78.99 c0.16,0.11,0.3,0.19,0.44,0.28l197.41-113.88c7.43-12.91,14.15-26.7,19.97-41.02c12.99-32.34,19.81-64.87,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C2056.22,1057.09,2044.21,1054.07,2031.19,1054.07z",
    className: "color373b42 svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2076.28,1170.16c0.08,50.6-26.36,109.55-64.35,150.41l-85.56,49.36 c-37.98,2.96-64.74-25.19-64.82-75.79c-0.23-68.23,47.73-151.19,106.93-185.42 C2027.76,1074.56,2076.12,1102.01,2076.28,1170.16z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1920.99,1372.09c-15.03,0-28.3-4.96-38.64-14.51c-14.84-13.71-22.71-35.65-22.75-63.45 c-0.24-68.63,48.17-152.57,107.91-187.11c29.42-16.96,57.21-19.64,78.26-7.51c20.86,12.02,32.38,37.11,32.46,70.63l0,0 c0.08,49.71-25.39,109.28-64.88,151.74c-0.13,0.14-0.28,0.26-0.45,0.36l-85.56,49.36c-0.25,0.15-0.53,0.24-0.82,0.26 C1924.66,1372.02,1922.81,1372.09,1920.99,1372.09z M2016.62,1095.94c-14.43,0-30.49,4.85-47.16,14.47 c-58.66,33.92-106.19,116.33-105.96,183.72c0.04,26.69,7.48,47.64,21.5,60.59c10.67,9.85,24.68,14.43,40.78,13.3 l84.92-48.99c38.73-41.77,63.7-100.17,63.63-148.87l0,0c-0.08-32.08-10.91-55.97-30.51-67.26 C2035.75,1098.24,2026.58,1095.94,2016.62,1095.94z",
    className: "color373b42 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2108.8,1151.36c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48C2045.7,1026.76,2108.57,1062.55,2108.8,1151.36 z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.67-0.09-0.97-0.26l-0.47-0.27c-0.4-0.22-0.75-0.42-1.12-0.66 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.15-2.75-0.24-5.59-0.24-8.44c-0.23-89.27,62.77-198.36,140.44-243.17 c38.16-22.02,74.14-25.53,101.3-9.88c26.98,15.53,41.9,48.05,42.02,91.57l0,0c0.08,29.7-6.85,62.74-20.03,95.55 c-5.96,14.66-12.85,28.77-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.82,114.7 C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M2031.19,1054.07c-18.91,0-39.95,6.37-61.81,18.98 c-76.59,44.19-138.72,151.76-138.49,239.79c0,2.78,0.08,5.55,0.24,8.24c1.77,36.87,15.32,64.91,38.15,78.99 c0.16,0.11,0.3,0.19,0.44,0.28l197.41-113.88c7.43-12.91,14.15-26.7,19.97-41.02c12.99-32.34,19.81-64.87,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C2056.22,1057.09,2044.21,1054.07,2031.19,1054.07z",
    className: "color373b42 svgShape"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1532.36c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l169.84-98.67 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-169.84,98.67 C2013.27,1532.27,2012.94,1532.36,2012.6,1532.36z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1578.39c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l169.84-98.67 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-169.84,98.67 C2013.27,1578.3,2012.94,1578.39,2012.6,1578.39z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1624.42c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l169.84-98.67 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-169.84,98.67 C2013.27,1624.33,2012.94,1624.42,2012.6,1624.42z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1670.45c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l102.3-59.44 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-102.3,59.44 C2013.27,1670.36,2012.94,1670.45,2012.6,1670.45z",
    className: "colorffffff svgShape"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1570.51,2035.74c0,4.21-2.73,8.42-8.27,11.54l-273.69,157.97c-5.3,3.12-12.17,4.68-19.11,4.76 c-7.49,0.08-14.98-1.48-20.67-4.76l-271.82-157.97c-5.46-3.04-8.19-7.25-8.19-11.38l-0.16-313.77 c0,4.13,2.73,8.19,8.11,11.38l271.89,157.97c5.69,3.27,13.26,4.83,20.83,4.68c6.86-0.16,13.65-1.72,18.95-4.68 l273.53-157.97c5.62-3.27,8.35-7.41,8.35-11.62L1570.51,2035.74z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1268.89,2211.97c-7.98,0-15.45-1.77-21.09-5.02l-271.82-157.98c-5.81-3.24-9.16-8.01-9.16-13.07 l-0.15-313.76l0,0c0-1.08,0.88-1.95,1.95-1.95s1.95,0.87,1.95,1.95c0,3.52,2.54,6.97,7.16,9.71l271.88,157.96 c5.13,2.95,12.21,4.63,19.81,4.42c6.79-0.15,13.2-1.73,18.04-4.43l273.5-157.96c4.75-2.77,7.37-6.3,7.37-9.93 c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95l0.24,313.84l0,0c0,5.18-3.29,9.88-9.26,13.24l-273.67,157.97 c-5.36,3.15-12.49,4.93-20.06,5.02C1269.28,2211.97,1269.08,2211.97,1268.89,2211.97z M970.57,1731.14l0.14,304.76 c0,3.61,2.62,7.14,7.19,9.68l271.85,157.99c5.17,2.97,12.21,4.59,19.67,4.49c6.91-0.08,13.35-1.67,18.14-4.49l273.7-157.98 c4.71-2.65,7.29-6.15,7.29-9.85l-0.23-304.77c-1.44,1.54-3.25,2.97-5.42,4.23l-273.53,157.98 c-5.41,3.02-12.46,4.77-19.88,4.94c-8.31,0.14-16.01-1.58-21.85-4.94l-271.9-157.98 C973.69,1733.98,971.95,1732.61,970.57,1731.14z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#becccd",
    d: "M1269.44,2210.01c-7.49,0.08-14.98-1.48-20.67-4.76l-271.82-157.97c-5.46-3.04-8.19-7.25-8.19-11.38 l-0.16-313.77c0,4.13,2.73,8.19,8.11,11.38l271.89,157.97c5.69,3.27,13.26,4.83,20.83,4.68",
    className: "colorbec4cd svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1268.89,2211.97c-7.98,0-15.45-1.77-21.09-5.02l-271.82-157.98c-5.81-3.24-9.16-8.01-9.16-13.07 l-0.15-313.76l0,0c0-1.08,0.88-1.95,1.95-1.95s1.95,0.87,1.95,1.95c0,3.52,2.54,6.97,7.16,9.71l271.88,157.96 c5.13,2.95,12.21,4.63,19.81,4.42c0.97,0.08,1.96,0.83,1.99,1.91c0.02,1.08-0.83,1.97-1.91,1.99 c-8.25,0.14-16.01-1.59-21.84-4.94l-271.9-157.98c-2.06-1.23-3.79-2.59-5.17-4.07l0.14,304.76c0,3.61,2.62,7.14,7.19,9.68 l271.85,157.99c5.17,2.97,12.21,4.59,19.67,4.49c0.01,0,0.02,0,0.02,0c1.07,0,1.93,0.86,1.95,1.93 c0.01,1.07-0.85,1.96-1.93,1.97C1269.28,2211.97,1269.08,2211.97,1268.89,2211.97z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1308.43 1924.9 1531.34 1796.18 1531.49 2020.02 1308.43 2148.78",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M976.91,1710.48c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03 l273.6-157.92c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L976.91,1710.48z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1268.41,1898.13c-7.55,0-15.08-1.66-20.8-4.98L975.75,1735.2c-5.89-3.42-9.12-8.08-9.11-13.14 c0-5.1,3.3-9.81,9.3-13.26l273.59-157.92c11.54-6.67,30.27-6.68,41.72-0.02l271.86,157.94c5.89,3.42,9.12,8.09,9.11,13.14 c-0.01,5.09-3.31,9.8-9.3,13.26l-273.59,157.92C1283.55,1896.45,1275.97,1898.13,1268.41,1898.13z M1270.45,1549.71 c-6.86,0-13.73,1.52-18.98,4.54l-273.59,157.92l0,0c-4.74,2.73-7.35,6.25-7.35,9.89c-0.01,3.6,2.54,7.07,7.18,9.76 l271.86,157.95c10.36,6.03,27.33,6.02,37.81-0.03l273.59-157.92c4.74-2.73,7.34-6.24,7.35-9.89 c0.01-3.6-2.54-7.07-7.18-9.76l-271.86-157.94C1284.11,1551.22,1277.29,1549.71,1270.45,1549.71z M976.91,1710.49h0.05 H976.91z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1094.36 1762.2 1339.42 1620.76 1437.24 1677.61 1192.18 1818.98",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1192.17,1820.92c-0.33,0-0.68-0.09-0.97-0.26l-97.82-56.77c-0.61-0.35-0.97-0.99-0.97-1.69 c0-0.69,0.37-1.34,0.97-1.68l245.06-141.45c0.61-0.35,1.35-0.35,1.96,0l97.83,56.85c0.6,0.35,0.97,0.99,0.97,1.69 c0,0.7-0.37,1.34-0.97,1.69l-245.07,141.36C1192.85,1820.84,1192.51,1820.92,1192.17,1820.92z M1098.25,1762.21 l93.93,54.51l241.18-139.12l-93.93-54.59L1098.25,1762.21z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1390.44,1477.98c-25.48-14.8-60.67-12.7-99.58,9.71c-77.26,44.64-139.71,152.85-139.46,241.56 c0.08,44.16,15.69,75.13,40.77,89.77l-56.95-33.16c-25.16-14.56-40.69-45.61-40.85-89.69 c-0.24-88.8,62.21-197,139.46-241.57c38.91-22.48,74.1-24.5,99.58-9.7L1390.44,1477.98z",
    className: "color373b42 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1192.16,1820.96c-0.34,0-0.67-0.08-0.98-0.27l0,0c-0.01,0-0.02-0.01-0.02-0.01l-56.93-33.15 c-26.81-15.51-41.66-47.96-41.82-91.36c-0.24-89.33,62.75-198.45,140.44-243.26c38.23-22.08,74.28-25.53,101.54-9.7 l57.03,33.08c0.01,0,0,0,0.01,0c0.93,0.54,1.24,1.73,0.7,2.67c-0.54,0.94-1.74,1.24-2.66,0.71h-0.01 c-25.93-15.05-60.6-11.62-97.63,9.71c-76.6,44.26-138.73,151.87-138.49,239.87c0.08,41.87,14.22,73.15,39.8,88.09 c0.93,0.54,1.24,1.74,0.7,2.67C1193.48,1820.62,1192.83,1820.96,1192.16,1820.96z M1296.53,1437.32 c-18.91,0-39.92,6.37-61.73,18.97c-76.6,44.19-138.73,151.8-138.49,239.88c0.15,41.96,14.32,73.21,39.88,88 l37.01,21.55c-15.4-17.77-23.7-44.09-23.76-76.47c-0.24-89.24,62.75-198.37,140.44-243.25 c28.69-16.52,56.14-22.59,79.53-17.96l-36.98-21.45C1321.77,1440.4,1309.65,1437.32,1296.53,1437.32z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1431.24,1567.74c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.62,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48 C1368.14,1443.14,1431,1478.93,1431.24,1567.74z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1192.17,1820.92c-0.33,0-0.67-0.09-0.97-0.26l-0.49-0.27c-0.39-0.21-0.75-0.41-1.1-0.65 c-23.89-14.74-38.1-43.9-39.94-82.07c-0.15-2.75-0.24-5.59-0.24-8.44c-0.23-89.27,62.77-198.36,140.44-243.17 c38.16-22.01,74.13-25.52,101.3-9.88c26.97,15.53,41.9,48.05,42.01,91.57l0,0c0.08,29.7-6.85,62.74-20.03,95.54 c-5.96,14.65-12.85,28.76-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.82,114.7 C1192.85,1820.84,1192.51,1820.92,1192.17,1820.92z M1353.63,1470.45c-18.91,0-39.95,6.37-61.81,18.98 c-76.59,44.2-138.72,151.77-138.49,239.8c0,2.77,0.08,5.54,0.24,8.24c1.77,36.86,15.32,64.91,38.15,79 c0.16,0.11,0.3,0.19,0.44,0.27l197.41-113.88c7.43-12.91,14.16-26.72,19.97-41.02 c12.99-32.34,19.81-64.87,19.74-94.07l0,0c-0.11-42.06-14.34-73.39-40.06-88.2 C1378.66,1473.47,1366.65,1470.45,1353.63,1470.45z",
    className: "color373b42 svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1398.71,1586.54c0.08,50.6-26.36,109.55-64.35,150.41l-85.56,49.36 c-37.98,2.96-64.74-25.19-64.81-75.79c-0.23-68.23,47.73-151.19,106.93-185.42 C1350.2,1490.94,1398.56,1518.39,1398.71,1586.54z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1243.43,1788.47c-15.03,0-28.3-4.96-38.64-14.51c-14.84-13.71-22.71-35.65-22.75-63.45 c-0.24-68.63,48.17-152.57,107.91-187.11c29.42-16.96,57.22-19.62,78.26-7.51c20.86,12.02,32.39,37.11,32.46,70.63l0,0 c0.08,49.72-25.39,109.28-64.88,151.74c-0.13,0.14-0.28,0.26-0.45,0.36l-85.56,49.36c-0.25,0.15-0.53,0.24-0.82,0.26 C1247.09,1788.39,1245.25,1788.47,1243.43,1788.47z M1339.06,1512.32c-14.43,0-30.49,4.85-47.17,14.46 c-58.66,33.92-106.19,116.34-105.96,183.72c0.04,26.69,7.48,47.64,21.5,60.59c10.67,9.85,24.69,14.41,40.78,13.3 l84.92-48.99c38.73-41.76,63.7-100.17,63.63-148.87l0,0c-0.08-32.08-10.91-55.96-30.51-67.26 C1358.18,1514.63,1349.01,1512.32,1339.06,1512.32z",
    className: "color373b42 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1431.2,1567.78c0.08,30.49-7.17,63.16-19.88,94.82c-5.77,14.19-12.55,28.23-20.35,41.72 l-50.6,29.24l-6,3.43l-84.45,48.73l-1.09,0.62l-56.61,32.67c-0.55-0.31-1.01-0.55-1.48-0.86 c-22.61-13.96-37.27-41.64-39.14-80.55c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.73,62.22-196.88,139.5-241.48 C1368.12,1443.18,1430.96,1478.97,1431.2,1567.78z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1192.21,1820.96c-0.33,0-0.66-0.08-0.97-0.26l-0.46-0.26c-0.4-0.22-0.77-0.43-1.14-0.67 c-23.94-14.77-38.17-43.94-40.01-82.07c-0.15-2.75-0.23-5.59-0.23-8.44c-0.24-89.24,62.77-198.33,140.47-243.17 c38.13-22.01,74.1-25.53,101.27-9.88c26.97,15.53,41.9,48.05,42.01,91.57l0,0c0.08,29.69-6.85,62.73-20.02,95.55 c-5.96,14.65-12.85,28.76-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.75,114.7 C1192.88,1820.87,1192.55,1820.96,1192.21,1820.96z M1353.61,1470.48c-18.91,0-39.95,6.37-61.79,18.98 c-76.61,44.22-138.75,151.79-138.52,239.8c0,2.77,0.08,5.54,0.23,8.24c1.77,36.83,15.34,64.88,38.22,79 c0.16,0.11,0.3,0.19,0.45,0.28l197.34-113.89c7.43-12.91,14.16-26.71,19.97-41.02c12.98-32.34,19.81-64.88,19.74-94.08 l0,0c-0.11-42.07-14.34-73.39-40.06-88.2C1378.63,1473.5,1366.63,1470.48,1353.61,1470.48z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1339.6,1644.92c1.77,2.47,2.7,6.17,2.71,11.1c0.02,6.22-1.18,12.37-3.54,18.49 c-2.36,6.16-6.15,12.02-11.4,17.67c-5.25,5.66-12.21,10.97-20.85,15.95l-2.1,1.21l0.05,16.98 c0.01,4.02-2.81,8.93-6.3,10.95c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-12.62,7.28l0.05,16.98 c0.01,4.02-2.81,8.93-6.3,10.95c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-19.73,11.39c-3.5,2.02-6.36,0.42-6.38-3.6 c-0.01-4.02,2.84-8.91,6.33-10.93l19.7-11.37l-0.23-82.78l-10.12,5.84c-3.5,2.02-6.33,0.4-6.35-3.62 c-0.01-4.02,2.81-8.9,6.3-10.92l10.16-5.86l-0.05-16.98c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65 l0.05,16.98l12.62-7.28l-0.05-16.98c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l1.28-0.74 c10.22-5.9,18.01-7.74,23.31-5.45c5.31,2.29,7.97,7.75,8,16.41c0.02,6.64-1.36,12.75-4.12,18.37 c-2.79,5.6-5.94,10.36-9.46,14.21c3.35-0.78,6.48-0.8,9.44-0.17C1335.47,1640.8,1337.82,1642.41,1339.6,1644.92z  M1327.8,1673.39c1.48-3.62,2.23-7.27,2.22-10.9c-0.02-6.32-2.16-9.7-6.39-10.2c-4.27-0.48-10.35,1.57-18.38,6.2 l-26.21,15.13l0.1,36.68l12.59-7.27l12.65-7.3l0.85-0.49c6.42-3.7,11.4-7.35,14.98-10.96 C1323.8,1680.67,1326.32,1677.04,1327.8,1673.39 M1278.9,1625.69l0.1,34.76l23.14-13.36 c5.87-3.39,10.43-6.82,13.68-10.31c3.25-3.45,5.52-6.97,6.82-10.52c1.3-3.51,1.93-6.99,1.92-10.41 c-0.01-5.03-1.79-7.99-5.32-8.96c-3.54-0.93-8.47,0.41-14.79,4.06l-0.3,0.18l-12.65,7.3L1278.9,1625.69",
    className: "color1fb6ff svgShape"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1335.04,1948.65c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1335.71,1948.56,1335.38,1948.65,1335.04,1948.65z M1372.79,1926.71c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1373.46,1926.63,1373.13,1926.71,1372.79,1926.71z M1410.55,1904.78c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1411.22,1904.69,1410.89,1904.78,1410.55,1904.78z M1448.31,1882.84c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1448.98,1882.76,1448.64,1882.84,1448.31,1882.84z M1486.06,1860.9c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1486.73,1860.82,1486.4,1860.9,1486.06,1860.9z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1335.04,1994.67c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1335.71,1994.59,1335.38,1994.67,1335.04,1994.67z M1372.79,1972.74c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1373.46,1972.66,1373.13,1972.74,1372.79,1972.74z M1410.55,1950.8c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1411.22,1950.72,1410.89,1950.8,1410.55,1950.8z M1448.31,1928.87c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1448.98,1928.79,1448.64,1928.87,1448.31,1928.87z M1486.06,1906.94c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1486.73,1906.85,1486.4,1906.94,1486.06,1906.94z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1335.04,2040.71c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1335.71,2040.62,1335.38,2040.71,1335.04,2040.71z M1372.79,2018.77c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1373.46,2018.69,1373.13,2018.77,1372.79,2018.77z M1410.55,1996.83c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1411.22,1996.75,1410.89,1996.83,1410.55,1996.83z M1448.31,1974.9c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1448.98,1974.82,1448.64,1974.9,1448.31,1974.9z M1486.06,1952.97c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1486.73,1952.88,1486.4,1952.97,1486.06,1952.97z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1335.04,2086.74c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1335.71,2086.65,1335.38,2086.74,1335.04,2086.74z M1372.79,2064.8c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1373.46,2064.72,1373.13,2064.8,1372.79,2064.8z M1410.55,2042.86c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1411.22,2042.78,1410.89,2042.86,1410.55,2042.86z",
    className: "colorffffff svgShape"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1410.49,1333.96c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l159.2-92.46 c3.67-2.13,5.86-5.94,5.86-10.18c0-4.25-2.19-8.05-5.86-10.18l-164.75-95.7c-4.88-2.84-7.8-7.91-7.8-13.55s2.92-10.71,7.8-13.55 l202.06-117.32c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-202.06,117.32c-3.67,2.13-5.86,5.94-5.86,10.18 c0,4.24,2.19,8.05,5.86,10.18l164.75,95.7c4.88,2.84,7.8,7.9,7.8,13.55c0,5.65-2.92,10.72-7.8,13.56l-159.2,92.46 C1411.16,1333.87,1410.82,1333.96,1410.49,1333.96z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2017.16,1227.94c1.77,2.47,2.7,6.17,2.71,11.1c0.02,6.22-1.18,12.37-3.54,18.49 c-2.36,6.16-6.15,12.02-11.4,17.67c-5.25,5.66-12.21,10.97-20.85,15.95l-2.1,1.21l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-12.62,7.28l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-19.73,11.39c-3.5,2.02-6.36,0.42-6.38-3.6c-0.01-4.02,2.84-8.91,6.33-10.93 l19.7-11.37l-0.23-82.78l-10.12,5.84c-3.5,2.02-6.33,0.4-6.35-3.62c-0.01-4.02,2.81-8.9,6.3-10.92l10.16-5.86l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l12.62-7.28l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l1.28-0.74c10.22-5.9,18.01-7.74,23.31-5.45 c5.31,2.29,7.97,7.75,8,16.41c0.02,6.64-1.36,12.75-4.12,18.37c-2.79,5.6-5.94,10.36-9.46,14.21c3.35-0.78,6.48-0.8,9.44-0.17 C2013.04,1223.81,2015.39,1225.43,2017.16,1227.94z M2005.36,1256.4c1.48-3.62,2.23-7.27,2.22-10.9 c-0.02-6.32-2.16-9.7-6.39-10.2c-4.27-0.48-10.35,1.57-18.38,6.2l-26.21,15.13l0.1,36.68l12.59-7.27l12.65-7.3l0.85-0.49 c6.42-3.7,11.4-7.35,14.98-10.96C2001.36,1263.68,2003.88,1260.06,2005.36,1256.4 M1956.47,1208.7l0.1,34.76l23.14-13.36 c5.87-3.39,10.43-6.82,13.68-10.31c3.25-3.45,5.52-6.97,6.82-10.52c1.3-3.51,1.93-6.99,1.92-10.41 c-0.01-5.03-1.79-7.99-5.32-8.96c-3.54-0.93-8.47,0.41-14.79,4.06l-0.3,0.18l-12.65,7.3L1956.47,1208.7",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1947.62,1337.68c-0.94,0-1.83-0.22-2.61-0.68c-1.8-1.04-2.84-3.14-2.85-5.77l-0.04-13.61l-16.82,9.71 c-2.3,1.32-4.64,1.49-6.46,0.45c-1.79-1.03-2.83-3.12-2.83-5.73c-0.01-4.71,3.21-10.25,7.31-12.62l18.72-10.81l-0.22-78.29 l-7.21,4.16c-2.29,1.32-4.64,1.49-6.44,0.45c-1.79-1.04-2.82-3.13-2.83-5.75c-0.02-4.71,3.18-10.25,7.28-12.61l9.18-5.3 l-0.05-15.85c-0.02-4.72,3.18-10.28,7.28-12.64c2.28-1.32,4.63-1.48,6.43-0.44c1.8,1.04,2.83,3.14,2.84,5.78l0.05,13.61 l8.73-5.03l-0.05-15.85c-0.01-4.73,3.19-10.28,7.28-12.65c2.28-1.32,4.62-1.48,6.42-0.44c1.8,1.04,2.85,3.14,2.86,5.77 l0.04,13.63c10.1-5.55,17.77-7.06,23.41-4.62c6.06,2.62,9.15,8.74,9.18,18.2c0.02,6.88-1.43,13.35-4.32,19.23 c-2.01,4.03-4.21,7.64-6.57,10.79c1.74-0.05,3.51,0.12,5.21,0.48c3.4,0.76,6.16,2.63,8.23,5.57c2.02,2.83,3.05,6.94,3.07,12.22 c0.02,6.36-1.21,12.82-3.67,19.2c-2.43,6.34-6.4,12.5-11.79,18.3c-5.34,5.75-12.51,11.24-21.31,16.31l-1.12,0.65l0.05,15.85 c0.01,4.73-3.19,10.28-7.28,12.64c-2.28,1.32-4.63,1.48-6.43,0.44c-1.8-1.04-2.83-3.14-2.84-5.77l-0.05-13.61l-8.73,5.04 l0.05,15.85c0.02,4.72-3.18,10.28-7.27,12.64C1950.15,1337.3,1948.84,1337.68,1947.62,1337.68z M1944.07,1312.29 c0.34,0,0.67,0.09,0.97,0.26c0.6,0.35,0.97,0.99,0.97,1.69l0.05,16.98c0.01,1.18,0.34,2.09,0.89,2.41 c0.56,0.32,1.5,0.16,2.54-0.44c2.9-1.67,5.34-5.91,5.32-9.25l-0.05-16.98c0-0.7,0.37-1.34,0.97-1.69l12.62-7.28 c0.61-0.35,1.34-0.35,1.95,0c0.6,0.35,0.97,0.99,0.97,1.68l0.05,16.98c0,1.19,0.34,2.09,0.89,2.41 c0.54,0.32,1.49,0.15,2.53-0.44c2.89-1.67,5.34-5.91,5.33-9.26l-0.05-16.98c0-0.7,0.37-1.34,0.97-1.69l2.09-1.21 c8.46-4.88,15.32-10.13,20.39-15.59c5.12-5.51,8.73-11.09,11.01-17.04c2.28-5.92,3.43-11.91,3.41-17.78 c-0.02-4.47-0.8-7.82-2.35-9.97c0,0-0.01-0.01-0.01-0.01c-1.52-2.15-3.44-3.46-5.89-4.01c-2.7-0.58-5.59-0.53-8.57,0.16 c-0.82,0.19-1.69-0.18-2.12-0.91c-0.43-0.74-0.34-1.67,0.24-2.3c3.35-3.67,6.43-8.3,9.15-13.76c2.62-5.33,3.94-11.22,3.91-17.49 c-0.02-7.87-2.25-12.66-6.82-14.63c-4.68-2.01-11.92-0.22-21.56,5.34l-1.28,0.74c-0.61,0.35-1.34,0.35-1.95,0 c-0.6-0.35-0.97-0.99-0.97-1.69l-0.05-16.98c-0.01-1.18-0.34-2.09-0.9-2.41c-0.55-0.33-1.5-0.15-2.53,0.44 c-2.89,1.68-5.34,5.92-5.33,9.26l0.05,16.97c0,0.7-0.37,1.35-0.97,1.69l-12.62,7.28c-0.61,0.35-1.34,0.35-1.95,0 c-0.6-0.35-0.97-0.99-0.97-1.68l-0.05-16.97c0-1.19-0.33-2.09-0.89-2.41c-0.56-0.33-1.51-0.15-2.53,0.44 c-2.9,1.68-5.35,5.92-5.33,9.26l0.05,16.98c0,0.7-0.37,1.34-0.97,1.69l-10.15,5.86c-2.9,1.68-5.35,5.89-5.33,9.22 c0,1.18,0.33,2.07,0.88,2.38c0.55,0.32,1.5,0.16,2.54-0.45l10.13-5.84c0.61-0.35,1.34-0.35,1.95,0c0.6,0.35,0.97,0.99,0.97,1.69 l0.23,82.79c0,0.7-0.37,1.34-0.97,1.69l-19.7,11.37c-2.91,1.68-5.37,5.91-5.36,9.24c0.01,1.17,0.33,2.05,0.88,2.36 c0.55,0.34,1.52,0.16,2.57-0.45l19.74-11.39C1943.4,1312.38,1943.73,1312.29,1944.07,1312.29z M1956.71,1295.25 c-0.33,0-0.67-0.09-0.97-0.26c-0.6-0.35-0.97-0.99-0.97-1.69l-0.11-36.68c0-0.7,0.37-1.34,0.97-1.69l26.21-15.13 c8.44-4.87,14.8-7.02,19.57-6.45c3.7,0.43,8.1,2.89,8.13,12.13c0.01,3.88-0.79,7.8-2.37,11.65c-1.58,3.89-4.28,7.77-8,11.52 c-3.69,3.72-8.87,7.51-15.4,11.27l-26.09,15.06C1957.38,1295.17,1957.04,1295.25,1956.71,1295.25z M1958.55,1257.75l0.1,32.18 l23.17-13.38c6.23-3.59,11.13-7.17,14.57-10.64c3.37-3.39,5.78-6.83,7.17-10.25v0c1.39-3.38,2.09-6.8,2.08-10.16 c-0.03-7.73-3.4-8.12-4.68-8.27c-3.81-0.43-9.59,1.58-17.18,5.95L1958.55,1257.75z M1956.56,1245.41 c-0.34,0-0.67-0.09-0.97-0.26c-0.6-0.35-0.97-0.99-0.97-1.69l-0.1-34.75c0-0.7,0.37-1.34,0.97-1.69l25.24-14.57 c7.13-4.12,12.43-5.53,16.56-4.43c3.1,0.85,6.77,3.41,6.78,10.84c0.02,3.66-0.67,7.4-2.04,11.09 c-1.38,3.79-3.81,7.55-7.23,11.17c-3.35,3.61-8.11,7.19-14.12,10.66l-23.14,13.35 C1957.23,1245.32,1956.9,1245.41,1956.56,1245.41z M1958.41,1209.83l0.09,30.26l20.22-11.67c5.67-3.27,10.13-6.62,13.23-9.95 c3.05-3.24,5.22-6.56,6.42-9.85c1.2-3.27,1.81-6.54,1.8-9.74c-0.01-5.4-2.22-6.63-3.89-7.09c-2.94-0.77-7.56,0.55-13.3,3.86 L1958.41,1209.83z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2248.06,1619.42c0,4.21-2.73,8.42-8.27,11.62l-273.61,157.9c-5.38,3.12-12.25,4.68-19.19,4.76 c-7.41,0.16-14.98-1.4-20.59-4.76l-271.89-157.9c-5.38-3.12-8.11-7.25-8.11-11.38l-0.23-313.84 c0,4.13,2.73,8.26,8.11,11.38l271.89,157.97c5.69,3.27,13.26,4.83,20.83,4.68c6.86-0.16,13.65-1.64,18.95-4.68 l273.53-157.97c5.62-3.2,8.35-7.33,8.35-11.54L2248.06,1619.42z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1945.98,1795.65c-7.73,0-15.18-1.82-20.57-5.04l-271.88-157.88c-5.85-3.39-9.08-8.03-9.08-13.07 l-0.24-313.84l0,0c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95c0,3.59,2.54,7.03,7.14,9.7l271.9,157.98 c5.13,2.96,12.22,4.56,19.81,4.41c6.91-0.16,13.32-1.72,18.02-4.42l273.52-157.97c4.76-2.71,7.37-6.21,7.37-9.85 c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95l0.23,313.77l0,0c0,5.14-3.28,9.86-9.24,13.3l-273.62,157.9 c-5.43,3.15-12.59,4.93-20.13,5.02C1946.67,1795.64,1946.33,1795.65,1945.98,1795.65z M1648.12,1314.87l0.23,304.78 c0,3.59,2.54,7.03,7.13,9.7l271.9,157.9c5.04,3.02,12.19,4.64,19.57,4.49c6.91-0.08,13.38-1.67,18.24-4.49l273.62-157.9 c4.7-2.71,7.29-6.24,7.29-9.93l-0.22-304.71c-1.44,1.53-3.27,2.94-5.44,4.18l-273.52,157.97 c-5.34,3.06-12.21,4.76-19.88,4.94c-8.25,0.14-16.02-1.58-21.85-4.93l-271.9-157.98 C1651.24,1317.69,1649.5,1316.34,1648.12,1314.87z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#becccd",
    d: "M1946.99,1793.69c-7.41,0.16-14.98-1.4-20.59-4.76l-271.89-157.9c-5.38-3.12-8.11-7.25-8.11-11.38 l-0.23-313.84c0,4.13,2.73,8.26,8.11,11.38l271.89,157.97c5.69,3.27,13.26,4.83,20.83,4.68",
    className: "colorbec4cd svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1946,1795.65c-7.74,0-15.2-1.82-20.59-5.04l-271.88-157.88c-5.85-3.39-9.08-8.03-9.08-13.07 l-0.24-313.84l0,0c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95c0,3.59,2.54,7.03,7.14,9.7l271.9,157.98 c5.13,2.96,12.22,4.56,19.81,4.41c0.9,0.1,1.96,0.83,1.99,1.91s-0.83,1.97-1.91,1.99c-8.27,0.18-16.01-1.58-21.84-4.93 l-271.9-157.98c-2.06-1.19-3.79-2.54-5.17-4.01l0.23,304.78c0,3.59,2.54,7.03,7.13,9.7l271.9,157.9 c5.04,3.02,12.19,4.64,19.57,4.49c0.01,0,0.02,0,0.04,0c1.06,0,1.93,0.85,1.95,1.91c0.02,1.08-0.83,1.97-1.91,1.99 C1946.69,1795.64,1946.34,1795.65,1946,1795.65z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1985.99 1508.61 2208.91 1379.9 2209.06 1603.73 1985.99 1732.5",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1654.47,1294.2c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03 l273.6-157.92c11.04-6.37,11.1-16.68,0.18-23.03l-271.86-157.94c-10.92-6.35-28.72-6.35-39.76,0.03L1654.47,1294.2z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1945.98,1481.83c-7.55,0-15.08-1.66-20.8-4.98l-271.86-157.95c-5.89-3.42-9.12-8.09-9.11-13.14 c0-5.09,3.3-9.8,9.3-13.26l273.59-157.92c11.55-6.67,30.28-6.67,41.72-0.02l271.86,157.94c5.89,3.42,9.12,8.09,9.11,13.14 c-0.01,5.09-3.31,9.8-9.3,13.26l-273.59,157.92C1961.11,1480.17,1953.54,1481.83,1945.98,1481.83z M1655.45,1295.88 L1655.45,1295.88c-4.74,2.73-7.35,6.25-7.35,9.9c-0.01,3.6,2.54,7.07,7.18,9.76l271.86,157.95 c10.37,6.02,27.33,6.02,37.81-0.03l273.59-157.92c4.74-2.73,7.34-6.24,7.35-9.89c0.01-3.6-2.54-7.07-7.18-9.76 l-271.86-157.94c-10.37-6.03-27.33-6.02-37.81,0.02L1655.45,1295.88z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1771.92 1345.82 2016.98 1204.38 2114.8 1261.23 1869.74 1402.6",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.68-0.09-0.98-0.26l-97.82-56.77c-0.6-0.35-0.97-0.99-0.97-1.69 c0-0.69,0.37-1.34,0.97-1.68l245.06-141.44c0.61-0.35,1.35-0.35,1.96,0l97.83,56.85c0.6,0.35,0.97,0.99,0.97,1.69 c0,0.7-0.37,1.34-0.97,1.69l-245.07,141.36C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M1775.81,1345.83 l93.93,54.52l241.18-139.12l-93.93-54.59L1775.81,1345.83z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M2068,1061.6c-25.48-14.8-60.67-12.7-99.58,9.71c-77.26,44.64-139.71,152.85-139.46,241.56 c0.08,44.16,15.69,75.13,40.77,89.77l-56.95-33.16c-25.16-14.56-40.69-45.61-40.85-89.69 c-0.24-88.8,62.21-197,139.46-241.57c38.91-22.48,74.1-24.5,99.58-9.7L2068,1061.6z",
    className: "color373b42 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.72,1404.58c-0.33,0-0.67-0.08-0.98-0.27l-56.95-33.16 c-26.81-15.51-41.66-47.96-41.82-91.36c-0.24-89.33,62.75-198.45,140.44-243.26c38.22-22.09,74.29-25.53,101.54-9.7 l56.93,33.02c0.04,0.02,0.07,0.04,0.11,0.06c0.93,0.54,1.24,1.73,0.7,2.67c-0.54,0.93-1.75,1.24-2.66,0.71l-0.07-0.04 c-25.93-15.02-60.58-11.55-97.57,9.75c-76.6,44.26-138.73,151.87-138.49,239.87c0.07,41.86,14.21,73.15,39.8,88.09 c0.93,0.54,1.24,1.74,0.7,2.67C1871.05,1404.24,1870.39,1404.58,1869.72,1404.58z M1974.09,1020.94 c-18.91,0-39.92,6.37-61.73,18.97c-76.6,44.19-138.73,151.8-138.49,239.88c0.15,41.95,14.32,73.21,39.88,88 l37.01,21.55c-15.4-17.77-23.7-44.09-23.75-76.47c-0.24-89.24,62.75-198.37,140.44-243.25 c28.7-16.52,56.14-22.59,79.53-17.96l-36.98-21.45C1999.33,1024.02,1987.22,1020.94,1974.09,1020.94z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2108.8,1151.36c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48 C2045.7,1026.76,2108.57,1062.55,2108.8,1151.36z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.67-0.09-0.97-0.26l-0.47-0.27c-0.4-0.22-0.75-0.42-1.12-0.66 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.15-2.75-0.24-5.59-0.24-8.44c-0.23-89.27,62.77-198.36,140.44-243.17 c38.16-22.02,74.14-25.53,101.3-9.88c26.98,15.53,41.9,48.05,42.02,91.57l0,0c0.08,29.7-6.85,62.74-20.03,95.55 c-5.96,14.66-12.85,28.77-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.82,114.7 C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M2031.19,1054.07c-18.91,0-39.95,6.37-61.81,18.98 c-76.59,44.19-138.72,151.76-138.49,239.79c0,2.78,0.08,5.55,0.24,8.24c1.77,36.87,15.32,64.91,38.15,78.99 c0.16,0.11,0.3,0.19,0.44,0.28l197.41-113.88c7.43-12.91,14.15-26.7,19.97-41.02c12.99-32.34,19.81-64.87,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C2056.22,1057.09,2044.21,1054.07,2031.19,1054.07z",
    className: "color373b42 svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2076.28,1170.16c0.08,50.6-26.36,109.55-64.35,150.41l-85.56,49.36 c-37.98,2.96-64.74-25.19-64.82-75.79c-0.23-68.23,47.73-151.19,106.93-185.42 C2027.76,1074.56,2076.12,1102.01,2076.28,1170.16z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1920.99,1372.09c-15.03,0-28.3-4.96-38.64-14.51c-14.84-13.71-22.71-35.65-22.75-63.45 c-0.24-68.63,48.17-152.57,107.91-187.11c29.42-16.96,57.21-19.64,78.26-7.51c20.86,12.02,32.38,37.11,32.46,70.63l0,0 c0.08,49.71-25.39,109.28-64.88,151.74c-0.13,0.14-0.28,0.26-0.45,0.36l-85.56,49.36c-0.25,0.15-0.53,0.24-0.82,0.26 C1924.66,1372.02,1922.81,1372.09,1920.99,1372.09z M2016.62,1095.94c-14.43,0-30.49,4.85-47.16,14.47 c-58.66,33.92-106.19,116.33-105.96,183.72c0.04,26.69,7.48,47.64,21.5,60.59c10.67,9.85,24.68,14.43,40.78,13.3 l84.92-48.99c38.73-41.77,63.7-100.17,63.63-148.87l0,0c-0.08-32.08-10.91-55.97-30.51-67.26 C2035.75,1098.24,2026.58,1095.94,2016.62,1095.94z",
    className: "color373b42 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2108.8,1151.36c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48C2045.7,1026.76,2108.57,1062.55,2108.8,1151.36 z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1869.74,1404.55c-0.34,0-0.67-0.09-0.97-0.26l-0.47-0.27c-0.4-0.22-0.75-0.42-1.12-0.66 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.15-2.75-0.24-5.59-0.24-8.44c-0.23-89.27,62.77-198.36,140.44-243.17 c38.16-22.02,74.14-25.53,101.3-9.88c26.98,15.53,41.9,48.05,42.02,91.57l0,0c0.08,29.7-6.85,62.74-20.03,95.55 c-5.96,14.66-12.85,28.77-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.82,114.7 C1870.41,1404.46,1870.07,1404.55,1869.74,1404.55z M2031.19,1054.07c-18.91,0-39.95,6.37-61.81,18.98 c-76.59,44.19-138.72,151.76-138.49,239.79c0,2.78,0.08,5.55,0.24,8.24c1.77,36.87,15.32,64.91,38.15,78.99 c0.16,0.11,0.3,0.19,0.44,0.28l197.41-113.88c7.43-12.91,14.15-26.7,19.97-41.02c12.99-32.34,19.81-64.87,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C2056.22,1057.09,2044.21,1054.07,2031.19,1054.07z",
    className: "color373b42 svgShape"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1532.36c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C2013.27,1532.27,2012.94,1532.36,2012.6,1532.36z M2050.36,1510.42c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C2051.03,1510.34,2050.69,1510.42,2050.36,1510.42z M2088.12,1488.49c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2088.79,1488.4,2088.45,1488.49,2088.12,1488.49z M2125.87,1466.55c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2126.54,1466.47,2126.21,1466.55,2125.87,1466.55z M2163.63,1444.62c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C2164.3,1444.53,2163.96,1444.62,2163.63,1444.62z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1578.39c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C2013.27,1578.3,2012.94,1578.39,2012.6,1578.39z M2050.36,1556.45c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C2051.03,1556.37,2050.69,1556.45,2050.36,1556.45z M2088.12,1534.52c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2088.79,1534.43,2088.45,1534.52,2088.12,1534.52z M2125.87,1512.58c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2126.54,1512.5,2126.21,1512.58,2125.87,1512.58z M2163.63,1490.65c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C2164.3,1490.56,2163.96,1490.65,2163.63,1490.65z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1624.42c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C2013.27,1624.33,2012.94,1624.42,2012.6,1624.42z M2050.36,1602.48c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C2051.03,1602.4,2050.69,1602.48,2050.36,1602.48z M2088.12,1580.55c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2088.79,1580.46,2088.45,1580.55,2088.12,1580.55z M2125.87,1558.61c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2126.54,1558.53,2126.21,1558.61,2125.87,1558.61z M2163.63,1536.68c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C2164.3,1536.59,2163.96,1536.68,2163.63,1536.68z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2012.6,1670.45c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C2013.27,1670.36,2012.94,1670.45,2012.6,1670.45z M2050.36,1648.51c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C2051.03,1648.43,2050.69,1648.51,2050.36,1648.51z M2088.12,1626.58c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C2088.79,1626.49,2088.45,1626.58,2088.12,1626.58z",
    className: "colorffffff svgShape"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M2017.16,1227.94c1.77,2.47,2.7,6.17,2.71,11.1c0.02,6.22-1.18,12.37-3.54,18.49 c-2.36,6.16-6.15,12.02-11.4,17.67c-5.25,5.66-12.21,10.97-20.85,15.95l-2.1,1.21l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-12.62,7.28l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-19.73,11.39c-3.5,2.02-6.36,0.42-6.38-3.6c-0.01-4.02,2.84-8.91,6.33-10.93 l19.7-11.37l-0.23-82.78l-10.12,5.84c-3.5,2.02-6.33,0.4-6.35-3.62c-0.01-4.02,2.81-8.9,6.3-10.92l10.16-5.86l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l12.62-7.28l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l1.28-0.74c10.22-5.9,18.01-7.74,23.31-5.45 c5.31,2.29,7.97,7.75,8,16.41c0.02,6.64-1.36,12.75-4.12,18.37c-2.79,5.6-5.94,10.36-9.46,14.21c3.35-0.78,6.48-0.8,9.44-0.17 C2013.04,1223.81,2015.39,1225.43,2017.16,1227.94z M2005.36,1256.4c1.48-3.62,2.23-7.27,2.22-10.9 c-0.02-6.32-2.16-9.7-6.39-10.2c-4.27-0.48-10.35,1.57-18.38,6.2l-26.21,15.13l0.1,36.68l12.59-7.27l12.65-7.3l0.85-0.49 c6.42-3.7,11.4-7.35,14.98-10.96C2001.36,1263.68,2003.88,1260.06,2005.36,1256.4 M1956.47,1208.7l0.1,34.76l23.14-13.36 c5.87-3.39,10.43-6.82,13.68-10.31c3.25-3.45,5.52-6.97,6.82-10.52c1.3-3.51,1.93-6.99,1.92-10.41 c-0.01-5.03-1.79-7.99-5.32-8.96c-3.54-0.93-8.47,0.41-14.79,4.06l-0.3,0.18l-12.65,7.3L1956.47,1208.7",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1995.59,853.48c0,4.21-2.73,8.42-8.27,11.62L1713.71,1023c-5.38,3.12-12.25,4.68-19.19,4.76 c-7.41,0.16-14.98-1.4-20.59-4.76l-271.89-157.9c-5.38-3.12-8.11-7.25-8.11-11.38l-0.23-313.84 c0,4.13,2.73,8.26,8.11,11.38l271.89,157.97c5.69,3.28,13.34,4.83,20.83,4.68c6.86-0.16,13.73-1.72,18.95-4.68 l273.53-157.97c5.62-3.2,8.35-7.41,8.35-11.62L1995.59,853.48z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1693.51,1029.71c-7.72,0-15.18-1.82-20.57-5.04l-271.88-157.89c-5.85-3.4-9.08-8.04-9.08-13.07 l-0.23-313.84l0,0c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95c0,3.59,2.54,7.03,7.13,9.7l271.9,157.98 c5.14,2.96,12.28,4.6,19.8,4.41c6.87-0.16,13.27-1.72,18.03-4.42l273.52-157.97c4.76-2.71,7.37-6.23,7.37-9.93 c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95l0.24,313.84l0,0c0,5.14-3.28,9.86-9.24,13.3l-273.61,157.9 c-5.44,3.15-12.59,4.93-20.14,5.02C1694.19,1029.71,1693.85,1029.71,1693.51,1029.71z M1395.65,548.94l0.22,304.78 c0,3.58,2.54,7.03,7.13,9.7l271.9,157.9c5.06,3.02,12.14,4.63,19.57,4.49c6.91-0.08,13.38-1.67,18.25-4.49l273.61-157.9 c4.71-2.71,7.29-6.24,7.29-9.93l-0.23-304.72c-1.44,1.54-3.27,2.95-5.44,4.18l-273.52,157.97 c-5.32,3.02-12.37,4.77-19.88,4.94c-8.14,0.16-16.09-1.63-21.84-4.93l-271.9-157.98 C1398.77,551.75,1397.03,550.4,1395.65,548.94z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#becccd",
    d: "M1694.52,1027.75c-7.41,0.16-14.98-1.4-20.59-4.76l-271.89-157.9c-5.38-3.12-8.11-7.25-8.11-11.38 l-0.23-313.84c0,4.13,2.73,8.26,8.11,11.38l271.89,157.97c5.69,3.28,13.34,4.83,20.83,4.68",
    className: "colorbec4cd svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1693.52,1029.71c-7.74,0-15.19-1.82-20.59-5.04l-271.88-157.89c-5.85-3.4-9.08-8.04-9.08-13.07 l-0.23-313.84l0,0c0-1.08,0.88-1.95,1.95-1.95c1.07,0,1.95,0.87,1.95,1.95c0,3.59,2.54,7.03,7.13,9.7l271.9,157.98 c5.14,2.96,12.28,4.6,19.8,4.41c0.01,0,0.02,0,0.04,0c1.06,0,1.93,0.85,1.95,1.91c0.02,1.08-0.83,1.97-1.91,1.99 c-8.13,0.16-16.08-1.63-21.83-4.93l-271.9-157.98c-2.06-1.19-3.79-2.54-5.17-4.01l0.22,304.78c0,3.58,2.54,7.03,7.13,9.7 l271.9,157.9c5.06,3.02,12.14,4.63,19.57,4.49c0.01,0,0.02,0,0.04,0c1.06,0,1.93,0.85,1.95,1.91 c0.02,1.08-0.83,1.97-1.91,1.99C1694.21,1029.71,1693.86,1029.71,1693.52,1029.71z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#21929b",
    points: "1733.53 742.66 1956.44 613.95 1956.59 837.78 1733.53 966.54",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1402.01,528.25c-11.04,6.37-11.1,16.68-0.17,23.03l271.86,157.94c10.92,6.35,28.72,6.35,39.76-0.03 l273.6-157.92c11.04-6.37,11.1-16.68,0.18-23.03L1715.37,370.3c-10.92-6.35-28.72-6.35-39.76,0.03L1402.01,528.25z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1693.51,715.88c-7.55,0-15.08-1.66-20.8-4.98l-271.86-157.95c-5.89-3.42-9.12-8.08-9.12-13.14 c0.01-5.1,3.31-9.81,9.3-13.26l0,0l273.6-157.92c11.54-6.66,30.25-6.67,41.72-0.02l271.86,157.94 c5.88,3.42,9.12,8.09,9.11,13.14c-0.01,5.09-3.31,9.8-9.3,13.26l-273.6,157.92 C1708.65,714.22,1701.08,715.88,1693.51,715.88z M1402.98,529.93L1402.98,529.93c-4.73,2.73-7.34,6.25-7.35,9.9 c0,3.6,2.55,7.07,7.19,9.76l271.86,157.95c10.38,6.03,27.34,6.01,37.81-0.03l273.6-157.92c4.73-2.73,7.34-6.25,7.35-9.9 c0-3.6-2.54-7.07-7.18-9.76l-271.86-157.94c-10.38-6.03-27.34-6.01-37.81,0.02L1402.98,529.93z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#ffffff",
    points: "1519.46 579.87 1764.52 438.43 1862.34 495.28 1617.28 636.65",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1617.28,638.59c-0.34,0-0.68-0.09-0.98-0.26l-97.82-56.77c-0.6-0.35-0.97-0.99-0.97-1.69 c0-0.69,0.37-1.34,0.97-1.68l245.06-141.45c0.61-0.35,1.35-0.35,1.96,0l97.82,56.85c0.6,0.35,0.97,0.99,0.97,1.69 c0,0.7-0.37,1.34-0.97,1.69l-245.06,141.36C1617.95,638.51,1617.61,638.59,1617.28,638.59z M1523.35,579.88l93.93,54.51 l241.17-139.12l-93.93-54.59L1523.35,579.88z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1815.53,295.65c-25.48-14.8-60.67-12.7-99.58,9.71c-77.26,44.64-139.71,152.85-139.46,241.56 c0.08,44.16,15.69,75.13,40.77,89.77l-56.95-33.16c-25.16-14.56-40.69-45.61-40.85-89.69 c-0.24-88.8,62.21-197,139.46-241.57c38.91-22.48,74.1-24.5,99.58-9.7L1815.53,295.65z",
    className: "color373b42 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1617.26,638.63c-0.34,0-0.67-0.08-0.98-0.27l0,0c-0.02-0.01-0.03-0.02-0.05-0.02l-56.9-33.14 c-26.81-15.51-41.66-47.96-41.82-91.36c-0.24-89.33,62.75-198.46,140.44-243.26c38.22-22.08,74.29-25.52,101.54-9.7 l57.03,33.08c0.01,0,0,0,0.01,0c0.93,0.54,1.24,1.73,0.7,2.67c-0.54,0.94-1.74,1.24-2.66,0.71h-0.01 c-25.93-15.06-60.6-11.62-97.63,9.71c-76.6,44.26-138.73,151.87-138.49,239.87c0.07,41.85,14.2,73.13,39.79,88.08 l0.02,0.01l0,0c0.93,0.54,1.24,1.74,0.7,2.67C1618.59,638.29,1617.93,638.63,1617.26,638.63z M1721.62,255 c-18.9,0-39.92,6.36-61.72,18.96c-76.6,44.18-138.73,151.79-138.49,239.88c0.15,41.95,14.32,73.21,39.88,88 l37.01,21.55c-15.4-17.77-23.7-44.09-23.75-76.47c-0.24-89.24,62.75-198.37,140.44-243.25 c28.69-16.52,56.14-22.59,79.53-17.96l-36.98-21.45C1746.87,258.07,1734.75,255,1721.62,255z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1856.33,385.41c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48 C1793.24,260.81,1856.1,296.6,1856.33,385.41z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1617.28,638.59c-0.34,0-0.66-0.08-0.97-0.26c-0.84-0.47-1.22-0.68-1.6-0.94 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.16-2.75-0.24-5.59-0.24-8.44c-0.24-89.26,62.76-198.35,140.43-243.17 c38.16-22.03,74.14-25.52,101.31-9.88c26.97,15.53,41.9,48.05,42.01,91.57l0,0c0.08,29.68-6.85,62.72-20.03,95.55 c-5.97,14.67-12.86,28.79-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.81,114.7 C1617.95,638.51,1617.61,638.59,1617.28,638.59z M1778.73,288.12c-18.91,0-39.96,6.37-61.82,18.98 c-76.6,44.2-138.72,151.77-138.48,239.79c0,2.78,0.08,5.54,0.24,8.24c1.77,36.87,15.32,64.92,38.15,79 c0.16,0.11,0.3,0.19,0.44,0.28l197.4-113.88c7.43-12.9,14.15-26.69,19.98-41.02c12.99-32.35,19.81-64.89,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C1803.76,291.14,1791.75,288.12,1778.73,288.12z",
    className: "color373b42 svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1823.81,404.21c0.08,50.6-26.36,109.55-64.35,150.41l-85.56,49.36 c-37.98,2.96-64.74-25.19-64.82-75.79c-0.23-68.23,47.73-151.19,106.93-185.42 C1775.3,308.61,1823.65,336.06,1823.81,404.21z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1668.53,606.14c-15.03,0-28.3-4.96-38.64-14.51c-14.84-13.71-22.71-35.65-22.75-63.45 c-0.24-68.63,48.17-152.57,107.91-187.11c29.42-16.97,57.22-19.63,78.25-7.51c20.86,12.02,32.38,37.11,32.46,70.63l0,0 c0.08,49.7-25.38,109.26-64.86,151.74c-0.14,0.14-0.29,0.26-0.46,0.36l-85.56,49.36c-0.25,0.15-0.53,0.24-0.82,0.26 C1672.19,606.07,1670.35,606.14,1668.53,606.14z M1764.16,329.99c-14.43,0-30.49,4.85-47.16,14.47 c-58.66,33.91-106.19,116.33-105.96,183.72c0.04,26.69,7.48,47.64,21.5,60.59c10.67,9.85,24.69,14.43,40.78,13.3 l84.92-48.99c38.74-41.78,63.7-100.18,63.62-148.87l0,0c-0.07-32.08-10.9-55.96-30.5-67.26 C1783.28,332.29,1774.11,329.99,1764.16,329.99z",
    className: "color373b42 svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1856.33,385.41c0.08,30.49-7.18,63.16-19.89,94.82c-5.77,14.19-12.56,28.23-20.36,41.72 l-56.63,32.67l-85.56,49.36l-56.63,32.67c-0.55-0.31-1.01-0.55-1.48-0.86c-22.62-13.96-37.2-41.64-39.08-80.55 c-0.16-2.73-0.23-5.54-0.23-8.34c-0.23-88.74,62.16-196.88,139.46-241.48C1793.24,260.81,1856.1,296.6,1856.33,385.41z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1617.28,638.59c-0.34,0-0.66-0.08-0.97-0.26c-0.84-0.47-1.22-0.68-1.6-0.94 c-23.89-14.73-38.1-43.89-39.94-82.07c-0.16-2.75-0.24-5.59-0.24-8.44c-0.24-89.26,62.76-198.35,140.43-243.17 c38.16-22.03,74.14-25.52,101.31-9.88c26.97,15.53,41.9,48.05,42.01,91.57l0,0c0.08,29.68-6.85,62.72-20.03,95.55 c-5.97,14.67-12.86,28.79-20.48,41.96c-0.18,0.3-0.42,0.54-0.72,0.71l-198.81,114.7 C1617.95,638.51,1617.61,638.59,1617.28,638.59z M1778.73,288.12c-18.91,0-39.96,6.37-61.82,18.98 c-76.6,44.2-138.72,151.77-138.48,239.79c0,2.78,0.08,5.54,0.24,8.24c1.77,36.87,15.32,64.92,38.15,79 c0.16,0.11,0.3,0.19,0.44,0.28l197.4-113.88c7.43-12.9,14.15-26.69,19.98-41.02c12.99-32.35,19.81-64.89,19.74-94.08 l0,0c-0.11-42.06-14.34-73.39-40.06-88.19C1803.76,291.14,1791.75,288.12,1778.73,288.12z",
    className: "color373b42 svgShape"
  }))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1760.14,766.41c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1760.81,766.32,1760.48,766.41,1760.14,766.41z M1797.9,744.47c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1798.57,744.39,1798.23,744.47,1797.9,744.47z M1835.66,722.53c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1836.33,722.45,1835.99,722.53,1835.66,722.53z M1873.41,700.6c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1874.08,700.52,1873.74,700.6,1873.41,700.6z M1911.16,678.67c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67L1929,664.1c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1911.83,678.58,1911.5,678.67,1911.16,678.67z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1760.14,812.44c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1760.81,812.35,1760.48,812.44,1760.14,812.44z M1797.9,790.5c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1798.57,790.42,1798.23,790.5,1797.9,790.5z M1835.66,768.56c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1836.33,768.48,1835.99,768.56,1835.66,768.56z M1873.41,746.63c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1874.08,746.55,1873.74,746.63,1873.41,746.63z M1911.16,724.7c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1911.83,724.61,1911.5,724.7,1911.16,724.7z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1760.14,858.47c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1760.81,858.38,1760.48,858.47,1760.14,858.47z M1797.9,836.53c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1798.57,836.45,1798.23,836.53,1797.9,836.53z M1835.66,814.6c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1836.33,814.51,1835.99,814.6,1835.66,814.6z M1873.41,792.66c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1874.08,792.58,1873.74,792.66,1873.41,792.66z M1911.16,770.73c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l18.82-10.93c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-18.82,10.93C1911.83,770.64,1911.5,770.73,1911.16,770.73z",
    className: "colorffffff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1760.14,904.5c-0.67,0-1.32-0.35-1.68-0.97c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75 c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67l-20.22,11.75 C1760.81,904.41,1760.48,904.5,1760.14,904.5z M1797.9,882.56c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.23-11.75c0.94-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.23,11.75C1798.57,882.48,1798.23,882.56,1797.9,882.56z M1835.66,860.63c-0.67,0-1.32-0.35-1.68-0.97 c-0.54-0.93-0.23-2.12,0.7-2.67l20.22-11.75c0.93-0.54,2.12-0.23,2.67,0.71c0.54,0.93,0.23,2.12-0.7,2.67 l-20.22,11.75C1836.33,860.54,1835.99,860.63,1835.66,860.63z",
    className: "colorffffff svgShape"
  })))))))))))))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1764.7,461.99c1.77,2.47,2.7,6.17,2.71,11.1c0.02,6.22-1.18,12.37-3.54,18.49 c-2.36,6.16-6.15,12.02-11.4,17.67c-5.25,5.66-12.21,10.97-20.85,15.95l-2.1,1.21l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-12.62,7.28l0.05,16.98c0.01,4.02-2.81,8.93-6.3,10.95 c-3.5,2.02-6.33,0.37-6.35-3.65l-0.05-16.98l-19.73,11.39c-3.5,2.02-6.36,0.42-6.38-3.6c-0.01-4.02,2.84-8.91,6.33-10.93 l19.7-11.37l-0.23-82.78l-10.12,5.84c-3.5,2.02-6.33,0.4-6.35-3.62c-0.01-4.02,2.81-8.9,6.3-10.92l10.16-5.86l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l12.62-7.28l-0.05-16.98 c-0.01-4.02,2.81-8.93,6.3-10.95c3.5-2.02,6.33-0.37,6.35,3.65l0.05,16.98l1.28-0.74c10.22-5.9,18.01-7.74,23.31-5.45 c5.31,2.29,7.97,7.75,8,16.41c0.02,6.64-1.37,12.75-4.12,18.37c-2.79,5.6-5.94,10.36-9.46,14.21c3.35-0.78,6.48-0.8,9.44-0.17 C1760.57,457.86,1762.92,459.48,1764.7,461.99z M1752.9,490.45c1.48-3.62,2.23-7.27,2.22-10.9c-0.02-6.32-2.16-9.7-6.39-10.2 c-4.27-0.48-10.35,1.57-18.38,6.2l-26.21,15.13l0.1,36.68l12.59-7.27l12.65-7.3l0.85-0.49c6.42-3.7,11.4-7.35,14.98-10.96 C1748.9,497.73,1751.42,494.11,1752.9,490.45 M1704,442.75l0.1,34.76l23.14-13.36c5.87-3.39,10.43-6.82,13.68-10.31 c3.25-3.45,5.52-6.97,6.82-10.52c1.3-3.51,1.93-6.99,1.92-10.41c-0.01-5.03-1.79-7.99-5.32-8.96 c-3.54-0.93-8.47,0.41-14.79,4.06l-0.3,0.18l-12.65,7.3L1704,442.75",
    className: "color1fb6ff svgShape"
  })))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M618.88,1946.38c12.29,7.09,12.36,18.61,0.14,25.7l-156.21,90.75c-12.21,7.09-32.1,7.09-44.39,0 l-157.23-90.75c-12.29-7.09-12.36-18.61-0.14-25.7l156.21-90.75c12.21-7.09,32.1-7.09,44.39,0L618.88,1946.38z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M440.65,2070.07c-8.39,0-16.79-1.85-23.19-5.55l-157.23-90.75c-6.59-3.81-10.23-8.99-10.23-14.59 c-0.01-5.56,3.57-10.71,10.08-14.49l156.21-90.75c12.75-7.4,33.52-7.41,46.34,0l157.23,90.75c6.59,3.8,10.23,8.98,10.23,14.58 c0.01,5.57-3.57,10.71-10.08,14.5l-156.21,90.75C457.43,2068.22,449.04,2070.07,440.65,2070.07z M439.43,1852.24 c-7.68,0-15.36,1.69-21.18,5.08l-156.21,90.75c-5.26,3.05-8.16,7-8.15,11.12c0,4.15,2.95,8.13,8.28,11.22l157.23,90.75 c11.74,6.77,30.78,6.77,42.43,0l156.21-90.75c5.26-3.05,8.16-7,8.15-11.12c-0.01-4.15-2.95-8.13-8.28-11.21l0,0l-157.23-90.75 C454.81,1853.93,447.11,1852.24,439.43,1852.24z",
    className: "colordbdee4 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M377.08,1922.63c-35,20.2-35.19,52.94-0.35,73.18c34.77,20.2,91.31,20.2,126.32,0 c34.94-20.17,35.13-52.91,0.35-73.11C468.56,1902.46,412.02,1902.46,377.08,1922.63z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M439.8,2012.85c-23.22,0-46.43-5.12-64.05-15.36c-17.41-10.12-26.99-23.68-26.98-38.18 c0.02-14.58,9.74-28.21,27.34-38.37l0,0c35.44-20.46,92.98-20.43,128.27,0.07c17.39,10.1,26.96,23.65,26.94,38.15 c-0.02,14.57-9.72,28.19-27.3,38.34C486.28,2007.73,463.02,2012.85,439.8,2012.85z M440.22,1909.46 c-22.49,0-44.99,4.95-62.16,14.86l0,0c-16.36,9.44-25.37,21.87-25.39,35c-0.02,13.05,8.88,25.41,25.04,34.8 c34.17,19.86,89.97,19.85,124.36,0c16.33-9.43,25.33-21.85,25.35-34.97c0.02-13.05-8.86-25.39-25.01-34.77 C485.29,1914.44,462.76,1909.46,440.22,1909.46z M377.08,1922.63h0.05H377.08z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M382.17,1754.12l0.68,199.08c0.02,8.48,5.6,16.94,16.75,23.42c22.4,13.01,58.81,13.01,81.36,0 c11.32-6.53,16.98-15.12,16.95-23.69l-0.68-199.08c0.02,8.57-5.63,17.16-16.95,23.69c-22.54,13.01-58.96,13.01-81.36,0 C387.77,1771.06,382.19,1762.6,382.17,1754.12z",
    className: "colorffffff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M398.92,1777.54c11.13,6.46,25.71,9.7,40.34,9.74v199.05c-14.4-0.14-28.71-3.34-39.66-9.71 c-11.15-6.48-16.73-14.95-16.75-23.42l-0.68-199.09C382.19,1762.6,387.77,1771.06,398.92,1777.54z",
    className: "colordbdee4 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M440.22,1988.29c-15.08,0-30.15-3.32-41.61-9.98c-11.4-6.63-17.7-15.55-17.72-25.11l-0.68-199.08 c0,0,0,0,0,0c0-1.07,0.87-1.95,1.94-1.95h0.01c1.07,0,1.95,0.87,1.95,1.94v0.03c0.04,8.11,5.64,15.82,15.79,21.71 c21.81,12.68,57.44,12.68,79.4,0c10.33-5.96,16.01-13.77,15.98-21.99l0,0c0-1.08,0.87-1.95,1.94-1.96h0.01 c1.07,0,1.94,0.87,1.95,1.94c0,0,0,0,0,0l0.69,199.08c0.02,9.68-6.34,18.7-17.93,25.38 C470.41,1984.97,455.31,1988.29,440.22,1988.29z M384.16,1766.81l0.63,186.39c0.02,8.12,5.63,15.84,15.79,21.74 c21.81,12.68,57.44,12.68,79.4,0c10.33-5.96,16.01-13.77,15.98-22l-0.64-186.39c-3.03,4.74-7.78,9.05-14.07,12.68 c-23.04,13.3-60.41,13.3-83.31,0C391.81,1775.67,387.16,1771.44,384.16,1766.81z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M399.15,1730.41c-22.54,13.01-22.66,34.1-0.23,47.13c22.4,13.01,58.81,13.01,81.36,0 c22.51-12.99,22.62-34.08,0.23-47.09C458.07,1717.42,421.66,1717.42,399.15,1730.41z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M439.55,1789.21c-15.08,0-30.15-3.32-41.61-9.98c-11.44-6.65-17.73-15.6-17.72-25.2 c0.02-9.65,6.39-18.64,17.96-25.31l0,0c23.03-13.3,60.39-13.27,83.31,0.05c11.42,6.64,17.7,15.58,17.69,25.17 c-0.01,9.65-6.38,18.63-17.92,25.29C469.73,1785.88,454.63,1789.21,439.55,1789.21z M399.15,1730.41l0.97,1.69 c-10.31,5.95-16,13.74-16.01,21.95c-0.02,8.15,5.59,15.9,15.79,21.82c21.81,12.68,57.44,12.68,79.4,0 c10.29-5.94,15.97-13.73,15.98-21.92c0.02-8.15-5.58-15.88-15.75-21.79c-21.83-12.7-57.46-12.71-79.4-0.05L399.15,1730.41z",
    className: "color373b42 svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M401.55,1634.01l0.45,114.81c0.02,5.64,3.73,11.27,11.14,15.58c14.89,8.65,39.11,8.65,54.1,0 c7.53-4.35,11.29-10.05,11.27-15.75l-0.45-114.81c0.02,5.7-3.75,11.41-11.27,15.75c-14.99,8.65-39.21,8.65-54.1,0 C405.28,1645.28,401.57,1639.65,401.55,1634.01z",
    className: "colorffffff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M412.7,1649.58c7.33,4.26,16.93,6.4,26.57,6.47v114.79c-9.49-0.13-18.9-2.25-26.11-6.44 c-7.41-4.31-11.12-9.94-11.14-15.58l-0.45-114.81C401.57,1639.65,405.28,1645.28,412.7,1649.58z",
    className: "colordbdee4 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M440.16,1772.8c-10.15,0-20.29-2.24-28-6.72c-7.79-4.52-12.09-10.65-12.11-17.26l-0.45-114.79v0v-0.02 c0,0,0,0,0,0c0-1.07,0.87-1.95,1.94-1.95h0.01c1.07,0,1.94,0.87,1.95,1.94v0c0.02,5.16,3.62,10.09,10.17,13.89 c14.32,8.32,37.72,8.33,52.14,0c6.66-3.85,10.32-8.84,10.3-14.06c0-1.07,0.87-1.95,1.94-1.95h0.01 c1.07,0,1.94,0.87,1.95,1.94l0.45,114.81c0.02,6.69-4.33,12.88-12.25,17.45C460.47,1770.56,450.31,1772.8,440.16,1772.8z  M403.54,1644.49l0.41,104.33c0.02,5.16,3.62,10.1,10.17,13.9c14.33,8.33,37.72,8.33,52.14,0 c6.66-3.84,10.32-8.84,10.3-14.06l-0.41-104.35c-2.04,2.59-4.86,4.95-8.39,6.98c-15.5,8.95-40.65,8.94-56.06,0 C408.3,1649.29,405.55,1646.99,403.54,1644.49z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M412.85,1618.24c-14.99,8.65-15.07,22.68-0.15,31.34c14.89,8.65,39.11,8.65,54.1,0 c14.97-8.64,15.05-22.66,0.15-31.32C452.03,1609.6,427.81,1609.6,412.85,1618.24z",
    className: "color1fb6ff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M439.71,1657.98c-10.15,0-20.29-2.24-28-6.71c-7.81-4.54-12.11-10.69-12.11-17.32 c0.01-6.66,4.36-12.84,12.27-17.4l0,0c15.5-8.95,40.64-8.93,56.06,0.03c7.8,4.54,12.1,10.68,12.09,17.31 c-0.02,6.66-4.36,12.83-12.25,17.38C460.02,1655.75,449.86,1657.98,439.71,1657.98z M439.9,1613.7 c-9.43,0-18.88,2.08-26.07,6.23l0,0c-6.65,3.84-10.31,8.82-10.32,14.03c-0.01,5.17,3.6,10.13,10.17,13.94 c14.32,8.33,37.72,8.33,52.14,0c6.63-3.83,10.29-8.81,10.3-14.01c0.01-5.17-3.6-10.12-10.16-13.93 C458.8,1615.78,449.35,1613.7,439.9,1613.7z M412.85,1618.24h0.05H412.85z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 439.804,
    x2: 439.804,
    y1: 1660.52,
    y2: 1489.669,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1feeff",
    stopOpacity: 0.9,
    className: "stopColor1fb6ff svgShape"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffffff",
    stopOpacity: 0,
    className: "stopColorffffff svgShape"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M475.82,1481.75v151.84c-0.19,5.2-3.71,10.3-10.49,14.29c-14.2,8.17-37.04,8.17-51.15,0 c-6.78-3.99-10.21-9.1-10.4-14.29v-151.84H475.82z"
  })))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.07,1450.47c-8.44,4.87-8.48,12.76-0.1,17.63l145.2,84.45c8.39,4.87,22.01,4.87,30.45,0l230.23-132.85 c8.44-4.87,8.48-12.76,0.1-17.63l-145.2-84.45c-8.39-4.87-22.01-4.87-30.45,0L590.07,1450.47z",
    fill: "#000000",
    className: "color000000 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f5f5",
    d: "M983.54,1378.59c0,5.39-1.89,9.18-4.99,10.96l-226.43,131.51c3.1-1.78,4.94-5.57,4.99-10.9 c0-10.85-7.64-24.1-17.05-29.49l-124.83-72.08c-1.26-0.75-2.35-1.66-3.22-2.64c-1.89-2.18-2.87-4.65-3.39-6.25 c-0.69-2.12-1.32-5.68,0.8-7.52l226.83-131.8c-2.53,1.78-1.84,5.51-1.15,7.8c0.46,1.55,1.38,4.02,3.33,6.2 c0.86,1.03,1.95,1.95,3.27,2.7l124.78,72.03C975.96,1354.49,983.59,1367.8,983.54,1378.59z",
    className: "colorf0f2f5 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M752.11,1523.01c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.22-2.12,0.71-2.66l0.06-0.03 c2.51-1.48,3.92-4.74,3.97-9.2c0-10.23-7.21-22.71-16.07-27.78l-124.84-72.09c-1.4-0.82-2.67-1.87-3.7-3.03 c-1.63-1.88-2.9-4.21-3.78-6.95c-1.36-4.15-0.85-7.65,1.39-9.59l227.12-132.01c0.91-0.52,2.06-0.24,2.63,0.64 c0.56,0.88,0.33,2.04-0.53,2.65c-1.52,1.06-0.9,3.99-0.4,5.65c0.65,2.19,1.63,4.02,2.92,5.46c0.78,0.94,1.7,1.69,2.78,2.3 l124.79,72.03c10,5.69,18.09,19.69,18.02,31.19c0,5.94-2.12,10.43-5.97,12.64l-226.36,131.47c-0.02,0.01-0.05,0.03-0.07,0.04 C752.77,1522.93,752.45,1523.01,752.11,1523.01z M832.53,1264.8l-222.12,129.06c-0.86,0.78-0.58,3.25,0.06,5.22 c0.72,2.24,1.74,4.12,3.01,5.58c0.75,0.85,1.7,1.63,2.73,2.24l124.82,72.08c9.94,5.69,18.02,19.68,18.02,31.18 c-0.02,1.8-0.23,3.46-0.61,4.97l219.12-127.27c2.6-1.49,4.02-4.78,4.02-9.27c0,0,0-0.01,0-0.01c0.05-10.07-7.3-22.8-16.07-27.79 l-124.78-72.03c-1.48-0.83-2.76-1.89-3.8-3.14c-1.63-1.82-2.89-4.15-3.69-6.89C832.79,1267.23,832.57,1265.93,832.53,1264.8z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M966.49,1349.1c9.47,5.39,17.11,18.71,17.05,29.49c0,5.39-1.89,9.18-4.99,10.96l-226.43,131.51 c3.1-1.78,4.94-5.57,4.99-10.9c0-10.85-7.64-24.1-17.05-29.49",
    className: "colordbdee4 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M752.11,1523.01c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.22-2.12,0.71-2.66l0.06-0.03 c2.51-1.48,3.92-4.74,3.97-9.21c0-10.23-7.21-22.71-16.07-27.78c-0.94-0.53-1.26-1.72-0.72-2.66c0.53-0.94,1.71-1.27,2.66-0.72 c9.94,5.69,18.03,19.68,18.03,31.18c-0.02,1.8-0.23,3.46-0.61,4.97l219.12-127.27c2.6-1.49,4.02-4.78,4.02-9.27 c0.05-10.08-7.3-22.81-16.07-27.8c-0.94-0.53-1.26-1.72-0.72-2.66c0.53-0.94,1.72-1.26,2.66-0.73 c10.01,5.7,18.1,19.7,18.03,31.2c0,5.94-2.12,10.43-5.97,12.64l-226.36,131.47c-0.02,0.01-0.05,0.03-0.07,0.04 C752.77,1522.93,752.45,1523.01,752.11,1523.01z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M626.1,1231.6c9.47,5.47,17.07,18.66,17.04,29.5l-0.23,81.13c-0.06,19.79-6.81,34.57-19.06,41.51 l-13.65,7.82c-2.98,1.7-2.31,5.79-1.56,8.14c0.68,2.32,2.45,6.53,6.62,8.93l124.8,72.01c9.4,5.43,17.07,18.7,17.04,29.5 c-0.03,10.88-7.75,15.19-17.15,9.77l-124.8-72.01c-16.79-9.69-31.8-29.87-38.18-51.45c-6.38-21.54-2.76-39.82,9.1-46.66 l13.69-7.72c5.76-3.28,8.93-10.22,8.96-19.57l0.23-81.13C608.98,1230.53,616.7,1226.18,626.1,1231.6z",
    className: "color373b42 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M747.62,1524.21c-2.7,0-5.63-0.88-8.64-2.62l-124.8-72.01c-17.24-9.94-32.58-30.58-39.08-52.58 c-6.62-22.38-2.7-41.58,10.01-48.91l13.7-7.72c5.11-2.91,7.94-9.26,7.97-17.88l0.23-81.13c0.02-5.94,2.15-10.43,6-12.64 c3.88-2.23,8.87-1.8,14.07,1.19l0,0c10.14,5.85,18.05,19.55,18.02,31.19l-0.23,81.13c-0.05,20.57-7.17,35.91-20.05,43.21 l-13.65,7.8c-1.93,1.1-1.11,4.47-0.67,5.86c0.6,2.06,2.13,5.76,5.73,7.83l124.8,72.02c9.97,5.75,18.05,19.74,18.02,31.19 c-0.02,5.95-2.15,10.44-5.99,12.65C751.42,1523.74,749.58,1524.21,747.62,1524.21z M618.46,1231.21c-1.3,0-2.48,0.3-3.52,0.89 c-2.6,1.49-4.03,4.79-4.04,9.27l-0.23,81.13c-0.03,10.07-3.56,17.62-9.94,21.26l-13.69,7.72c-11.08,6.38-14.3,23.82-8.2,44.42 c6.24,21.09,20.87,40.84,37.29,50.31l124.8,72.01c3.95,2.28,7.58,2.7,10.19,1.2c2.59-1.49,4.02-4.79,4.04-9.28 c0.03-10.03-7.33-22.77-16.07-27.81l-124.8-72.01c-4.78-2.76-6.76-7.49-7.52-10.07c-1.52-4.82-0.63-8.62,2.47-10.39l13.65-7.81 c11.6-6.58,18.02-20.72,18.08-39.82l0.23-81.13c0.03-10.2-7.18-22.68-16.07-27.8c0,0,0,0,0,0 C622.73,1231.91,620.46,1231.21,618.46,1231.21z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M850.33,1252.21c12.21-6.96,19.01-21.73,19.07-41.53l0.21-81.09c0-10.87-7.55-24.03-17.03-29.49 c-4.77-2.78-9.05-3-12.16-1.18l-226.48,131.51c3.11-1.82,7.44-1.55,12.16,1.18c9.48,5.46,17.08,18.68,17.03,29.49l-0.21,81.14 c-0.05,18.47-5.94,32.54-16.65,39.93c-0.05,0.11-0.11,0.16-0.16,0.16l-15.91,9.21c-0.27,0.16-0.54,0.32-0.75,0.64l226.8-131.78 L850.33,1252.21z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M609.44,1394.12c-0.53,0-1.05-0.22-1.43-0.62c-0.62-0.67-0.69-1.68-0.18-2.43 c0.46-0.67,1.03-1.01,1.36-1.21l15.72-9.1c0.08-0.07,0.16-0.14,0.25-0.21c10.14-6.99,15.75-20.61,15.81-38.32l0.21-81.14 c0.05-10.2-7.15-22.67-16.05-27.8c-3.88-2.25-7.58-2.69-10.14-1.22l-0.06,0.04c-0.94,0.53-2.12,0.22-2.67-0.7 s-0.23-2.12,0.69-2.67c0.03-0.02,0.05-0.03,0.08-0.04l226.41-131.47c3.91-2.28,8.91-1.86,14.12,1.18 c10.09,5.81,18,19.5,18,31.17l-0.22,81.09c-0.05,20.53-7.17,35.88-20.03,43.22l-240.88,139.96 C610.11,1394.03,609.78,1394.12,609.44,1394.12z M622.25,1227.86c1.58,0.43,3.21,1.12,4.83,2.06c9.98,5.75,18.05,19.74,18,31.19 l-0.21,81.13c-0.04,12.85-2.88,23.74-8.17,31.84l212.65-123.56c0.01,0,0.02,0,0.02-0.01c11.6-6.62,18.02-20.77,18.08-39.84 l0.22-81.09c0-10.23-7.2-22.7-16.06-27.8c-3.94-2.3-7.55-2.72-10.2-1.18L622.25,1227.86z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1164.07,308.54c-0.07-25.58-18.19-35.9-40.47-23.05L338.74,738.39c-22.28,12.85-40.28,44.01-40.21,69.6 l1.5,529.36l865.54-499.44L1164.07,308.54z",
    className: "color373b42 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M300.03,1339.3c-0.34,0-0.67-0.09-0.97-0.26c-0.6-0.35-0.97-0.99-0.97-1.69l-1.5-529.36 c-0.07-26.17,18.4-58.15,41.18-71.29l784.87-452.89c11.44-6.61,22.3-7.62,30.58-2.85c8.22,4.73,12.77,14.53,12.81,27.58 l1.5,529.37c0,0.7-0.37,1.34-0.97,1.69l-865.54,499.44C300.7,1339.21,300.37,1339.3,300.03,1339.3z M1141.69,281.9 c-5.2,0-11.03,1.77-17.11,5.28L339.71,740.07c-21.7,12.52-39.3,42.99-39.23,67.91l1.49,526l861.65-497.19l-1.5-528.24l0,0 c-0.03-11.6-3.88-20.2-10.85-24.21C1148.44,282.71,1145.21,281.9,1141.69,281.9z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M316.68,807.94c-0.05-19.08,14.49-44.25,31.13-53.84l784.87-452.89c4.85-2.8,7.93-3.1,9.02-3.1 c3.89,0,4.22,8.03,4.22,10.49l1.48,539.8l-829.31,478.57L316.68,807.94z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M318.09,1328.92c-0.34,0-0.67-0.09-0.97-0.26c-0.6-0.35-0.97-0.99-0.97-1.69l-1.41-519.03 c-0.05-19.69,14.95-45.64,32.1-55.54l784.87-452.89c5.07-2.92,8.44-3.36,10-3.36c3.96,0,6.15,4.42,6.18,12.43l1.48,539.81 c0,0.7-0.37,1.34-0.97,1.69l-829.32,478.57C318.76,1328.83,318.42,1328.92,318.09,1328.92z M1141.7,300.05 c-0.73,0-3.49,0.21-8.05,2.84L348.78,755.78c-16.11,9.3-30.21,33.67-30.15,52.16l0,0l1.4,515.67l825.42-476.32l-1.48-538.68 C1143.96,303.32,1142.78,300.05,1141.7,300.05z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M300.03,1337.35l0.22,78.32c0.07,25.58,18.19,35.9,40.47,23.05l784.87-452.89 c22.28-12.86,40.28-44.02,40.21-69.6l-0.22-78.32L300.03,1337.35z",
    className: "colordbdee4 svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M322.62,1446.22c-4.19,0-8.07-0.98-11.51-2.96c-8.22-4.73-12.77-14.52-12.81-27.58l-0.22-78.32 c0-0.7,0.37-1.34,0.97-1.69l865.54-499.44c0.61-0.35,1.34-0.35,1.95,0c0.6,0.35,0.97,0.99,0.97,1.69l0.23,78.32 c0.07,26.17-18.4,58.15-41.19,71.29L341.7,1440.41C335,1444.27,328.51,1446.22,322.62,1446.22z M301.98,1338.47l0.22,77.19 c0.04,11.6,3.89,20.2,10.86,24.21c7.02,4.05,16.51,3.03,26.69-2.84l784.86-452.89c21.7-12.52,39.31-42.98,39.24-67.91 l-0.22-74.95L301.98,1338.47z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#becccd",
    d: "M1152.34,282.67c-7.35-4.29-17.49-3.64-28.73,2.86L338.73,738.39c-6.5,3.77-12.67,9.16-18.07,15.46 c-3.84,4.35-7.21,9.09-10.14,14.16c-3.64,6.24-6.57,12.8-8.58,19.42c-2.21,6.95-3.45,13.9-3.38,20.53l1.69,607.74 c0.07,12.67,4.55,21.63,11.77,25.86l-46.61-27.09c-7.21-4.22-11.7-13.19-11.77-25.86l-1.69-607.74 c-0.07-6.56,1.1-13.45,3.25-20.33c2.08-6.62,5.01-13.19,8.58-19.36c2.99-5.07,6.37-9.94,10.21-14.29 c5.39-6.37,11.57-11.76,18.13-15.53l784.88-452.93c11.24-6.5,21.39-7.02,28.73-2.79L1152.34,282.67z",
    className: "colorbec4cd svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f0f5f5",
    d: "M320.66,753.85c-3.84,4.35-7.21,9.09-10.14,14.16c-3.64,6.24-6.57,12.8-8.58,19.42l-46.74-26.9 c2.08-6.62,5.01-13.19,8.58-19.36c2.99-5.07,6.37-9.94,10.21-14.29L320.66,753.85z",
    className: "colorf0f2f5 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M312.02,1443.52c-0.34,0-0.67-0.08-0.98-0.26l-46.62-27.1c-8.15-4.77-12.67-14.54-12.73-27.53l-1.69-607.74 c-0.07-12.72,4.23-27.17,12.09-40.68c7.75-13.35,18.07-24.2,29.05-30.53l784.88-452.93c11.43-6.6,22.32-7.6,30.68-2.79 l46.51,26.97c0.04,0.02,0.08,0.05,0.11,0.07c0.93,0.54,1.24,1.73,0.7,2.67c-0.54,0.93-1.74,1.24-2.66,0.7l-0.11-0.06 c-6.98-4.01-16.44-2.98-26.67,2.92L339.7,740.09c-10.39,6.02-20.16,16.29-27.5,28.92c-7.6,13.07-11.75,26.9-11.69,38.96 l1.69,607.75c0.05,11.55,3.89,20.14,10.8,24.18c0.93,0.54,1.24,1.74,0.7,2.67C313.34,1443.17,312.69,1443.52,312.02,1443.52z  M1095.04,254.85c-5.21,0-11.03,1.77-17.08,5.27L293.08,713.05c-10.4,6-20.21,16.33-27.63,29.11 c-7.52,12.91-11.62,26.66-11.56,38.71l1.69,607.75c0.05,11.55,3.89,20.14,10.8,24.18l35.74,20.78 c-2.47-4.84-3.78-10.88-3.81-17.84l-1.69-607.74c-0.07-12.74,4.27-27.28,12.22-40.94c7.68-13.21,17.96-23.97,28.92-30.33 l784.88-452.87c6.22-3.59,12.26-5.54,17.8-5.82l-35.68-20.7C1101.87,255.67,1098.6,254.85,1095.04,254.85z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M688.11,1176.28c0,7.51-5.25,16.62-11.79,20.38c-6.52,3.74-11.82,0.76-11.84-6.75s5.25-16.62,11.77-20.38 C682.77,1165.76,688.09,1168.76,688.11,1176.28z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M743.98,1144.04c0,7.51-5.25,16.62-11.79,20.38c-6.52,3.74-11.82,0.76-11.84-6.75s5.25-16.62,11.77-20.38 C738.64,1133.52,743.96,1136.53,743.98,1144.04z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M799.85,1111.8c0,7.51-5.25,16.62-11.79,20.38c-6.52,3.74-11.82,0.76-11.84-6.75s5.25-16.62,11.77-20.38 C794.51,1101.29,799.82,1104.29,799.85,1111.8z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 977.37,
    x2: 1025.81,
    y1: 457.98,
    y2: 430.02,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M977.37,459.93c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l48.44-27.95 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-48.44,27.95C978.04,459.84,977.71,459.93,977.37,459.93z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M729.13,603.17c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l212.23-122.46 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L730.1,602.91C729.8,603.08,729.47,603.17,729.13,603.17z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 541.78,
    x2: 679.51,
    y1: 709.32,
    y2: 629.85,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M541.78,711.27c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l137.73-79.47 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-137.73,79.47C542.45,711.19,542.11,711.27,541.78,711.27z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 683.07,
    x2: 916.12,
    y1: 699.44,
    y2: 564.96,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M683.07,701.39c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l233.05-134.48 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L684.04,701.13C683.74,701.31,683.4,701.39,683.07,701.39z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 541.78,
    x2: 637.56,
    y1: 780.97,
    y2: 725.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M541.78,782.91c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l95.78-55.26 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-95.78,55.26C542.45,782.83,542.11,782.91,541.78,782.91z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.46,
    x2: 492.37,
    y1: 777.6,
    y2: 737.83,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M423.46,779.55c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,779.46,423.8,779.55,423.46,779.55z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M423.46,851.19c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,851.11,423.8,851.19,423.46,851.19z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 916.12,
    x2: 1025.81,
    y1: 636.6,
    y2: 573.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M916.12,638.55c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l109.69-63.29 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L917.1,638.29C916.79,638.47,916.46,638.55,916.12,638.55z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 785.84,
    x2: 873.62,
    y1: 711.78,
    y2: 661.13,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M785.84,713.73c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l87.78-50.65 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-87.78,50.65C786.51,713.65,786.18,713.73,785.84,713.73z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M541.78,854.56c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l199.4-115.06 c0.91-0.54,2.12-0.22,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L542.75,854.3C542.45,854.48,542.11,854.56,541.78,854.56z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.46,
    x2: 492.37,
    y1: 920.88,
    y2: 881.12,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M423.46,922.83c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,922.75,423.8,922.83,423.46,922.83z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 868.43,
    x2: 984.06,
    y1: 735.77,
    y2: 669.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M868.42,737.72c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l115.64-66.73 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L869.4,737.46C869.09,737.64,868.76,737.72,868.42,737.72z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M641.48,868.67c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l174.6-100.75 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-174.6,100.75C642.15,868.59,641.81,868.67,641.48,868.67z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 541.78,
    x2: 585.49,
    y1: 924.26,
    y2: 899.03,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M541.78,926.2c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l43.71-25.22 c0.91-0.54,2.11-0.22,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-43.71,25.22C542.45,926.12,542.11,926.2,541.78,926.2z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M423.46,994.48c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,994.4,423.8,994.48,423.46,994.48z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M961.94,755.41c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l63.87-36.86 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-63.87,36.86C962.61,755.32,962.27,755.41,961.94,755.41z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 783.8,
    x2: 926.24,
    y1: 856.25,
    y2: 774.05,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M783.8,858.2c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l142.45-82.2 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-142.45,82.2C784.47,858.12,784.13,858.2,783.8,858.2z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M541.78,997.85c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l199.4-115.06 c0.91-0.54,2.12-0.22,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-199.4,115.06C542.45,997.76,542.11,997.85,541.78,997.85z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.46,
    x2: 492.37,
    y1: 1064.17,
    y2: 1024.41,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M423.46,1066.12c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,1066.04,423.8,1066.12,423.46,1066.12z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 926.24,
    x2: 999.7,
    y1: 845.7,
    y2: 803.31,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M926.24,847.65c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l73.45-42.38 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-73.45,42.38C926.91,847.56,926.58,847.65,926.24,847.65z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M724.66,963.96c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l148.64-85.77 c0.91-0.54,2.12-0.22,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66L725.63,963.7C725.33,963.88,725,963.96,724.66,963.96z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 541.78,
    x2: 668.66,
    y1: 1067.54,
    y2: 994.33,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M541.78,1069.49c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l126.87-73.21 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-126.87,73.21C542.45,1069.41,542.11,1069.49,541.78,1069.49z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M423.46,1137.77c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,1137.68,423.8,1137.77,423.46,1137.77z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M961.94,898.69c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l63.87-36.86 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-63.87,36.86C962.61,898.61,962.27,898.69,961.94,898.69z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 783.8,
    x2: 926.24,
    y1: 999.54,
    y2: 917.34,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M783.8,1001.49c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l142.45-82.2 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-142.45,82.2C784.47,1001.4,784.13,1001.49,783.8,1001.49z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M541.78,1141.14c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l199.4-115.06 c0.91-0.54,2.12-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-199.4,115.06C542.45,1141.05,542.11,1141.14,541.78,1141.14z",
    className: "color1fb6ff svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 423.46,
    x2: 492.37,
    y1: 1207.46,
    y2: 1167.7,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M423.46,1209.41c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,1209.33,423.8,1209.41,423.46,1209.41z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M423.46,851.19c-0.67,0-1.32-0.35-1.69-0.97c-0.53-0.93-0.21-2.12,0.72-2.66l68.91-39.76 c0.91-0.54,2.11-0.23,2.67,0.71c0.53,0.93,0.21,2.12-0.72,2.66l-68.91,39.76C424.13,851.11,423.8,851.19,423.46,851.19z",
    className: "color1fb6ff svgShape"
  }))))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M2017.77,1981.28c14.11-8.14,14.19-21.34,0.17-29.48c-14.01-8.14-36.82-8.14-50.93,0 c-14.11,8.14-14.17,21.34-0.16,29.48C1980.87,1989.42,2003.66,1989.42,2017.77,1981.28z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1992.28,1989.29c-9.57,0-19.14-2.11-26.41-6.33c-7.38-4.29-11.44-10.1-11.44-16.38 c0.01-6.31,4.13-12.16,11.6-16.47c14.62-8.43,38.34-8.44,52.88,0c7.37,4.29,11.43,10.1,11.42,16.38 c-0.01,6.32-4.13,12.17-11.6,16.48C2011.43,1987.19,2001.85,1989.29,1992.28,1989.29z M1992.52,1947.62 c-8.87,0-17.75,1.95-24.53,5.86c-6.22,3.59-9.65,8.24-9.66,13.1c-0.01,4.82,3.37,9.44,9.5,13c13.45,7.82,35.42,7.82,48.95,0 c6.22-3.59,9.65-8.25,9.66-13.12c0.01-4.82-3.36-9.44-9.49-12.99C2010.24,1949.58,2001.38,1947.62,1992.52,1947.62z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1992.47,1957.24c-5.5,0-10.82,1.25-14.6,3.43c-3.04,1.75-4.78,3.9-4.78,5.9c0,1.98,1.71,4.1,4.69,5.83 c3.75,2.18,9.05,3.43,14.54,3.43c5.49,0,10.81-1.25,14.59-3.43c3.04-1.75,4.78-3.91,4.79-5.91c0-1.98-1.7-4.1-4.68-5.83 C2003.26,1958.49,1997.97,1957.24,1992.47,1957.24z",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M2116.65,1886.6c-5.91,0-11.62,1.34-15.68,3.69c-3.26,1.88-5.13,4.19-5.14,6.34c0,2.12,1.83,4.41,5.03,6.27 c4.03,2.34,9.72,3.68,15.62,3.68c5.9,0,11.61-1.34,15.67-3.68c3.26-1.88,5.14-4.2,5.14-6.35c0-2.12-1.83-4.4-5.03-6.26 C2128.24,1887.94,2122.55,1886.6,2116.65,1886.6z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M1758.53,2099.08c-14.11,8.14-14.19,21.34-0.17,29.48s36.82,8.14,50.93,0 c14.11-8.14,14.17-21.34,0.16-29.48C1795.43,2090.94,1772.63,2090.94,1758.53,2099.08z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M1783.78,2136.58c-9.57,0-19.14-2.11-26.4-6.33c-7.38-4.29-11.44-10.1-11.43-16.38 c0.01-6.32,4.13-12.17,11.6-16.48l0,0c14.64-8.44,38.35-8.43,52.88,0c7.38,4.29,11.44,10.1,11.43,16.38 c-0.01,6.31-4.13,12.16-11.6,16.47C1802.94,2134.47,1793.36,2136.58,1783.78,2136.58z M1759.5,2100.77 c-6.22,3.59-9.65,8.25-9.66,13.11c-0.01,4.82,3.37,9.44,9.5,13c13.46,7.81,35.42,7.82,48.97,0c6.21-3.59,9.64-8.24,9.65-13.1 c0.01-4.82-3.37-9.44-9.5-13C1795.02,2092.96,1773.04,2092.95,1759.5,2100.77L1759.5,2100.77z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M1783.82,2123.12c5.5,0,10.82-1.25,14.6-3.43c3.04-1.75,4.78-3.9,4.78-5.9c0-1.98-1.71-4.1-4.69-5.83 c-3.75-2.18-9.05-3.43-14.54-3.43c-5.49,0-10.81,1.25-14.59,3.43c-3.04,1.75-4.78,3.91-4.79,5.91c0,1.98,1.7,4.1,4.68,5.83 C1773.03,2121.87,1778.33,2123.12,1783.82,2123.12z",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1659.65,2193.76c5.91,0,11.62-1.34,15.68-3.69c3.26-1.88,5.13-4.19,5.14-6.34c0-2.12-1.83-4.41-5.03-6.27 c-4.03-2.34-9.72-3.68-15.62-3.68c-5.9,0-11.61,1.34-15.67,3.68c-3.26,1.88-5.14,4.2-5.14,6.35c0,2.12,1.83,4.41,5.03,6.26 C1648.06,2192.42,1653.75,2193.76,1659.65,2193.76z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M434,2214.48c-14.11-8.14-14.19-21.34-0.17-29.48c14.01-8.14,36.82-8.14,50.93,0 c14.11,8.14,14.17,21.34,0.16,29.48S448.11,2222.62,434,2214.48z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M459.49,2222.5c-9.57,0-19.15-2.11-26.46-6.33v0c-7.48-4.31-11.6-10.17-11.6-16.48 c-0.02-6.27,4.04-12.09,11.42-16.38c14.53-8.43,38.25-8.44,52.88,0c7.47,4.31,11.6,10.16,11.6,16.47 c0.01,6.27-4.06,12.09-11.44,16.38C478.62,2220.39,469.06,2222.5,459.49,2222.5z M459.25,2180.83 c-8.87,0-17.72,1.95-24.44,5.86c-6.13,3.56-9.5,8.17-9.49,12.99c0.01,4.87,3.43,9.52,9.66,13.11l0,0 c13.54,7.81,35.51,7.82,48.95,0c6.14-3.56,9.51-8.17,9.5-13c-0.01-4.86-3.43-9.51-9.66-13.1 C477,2182.78,468.12,2180.83,459.25,2180.83z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M459.29,2190.44c5.5,0,10.82,1.25,14.6,3.43c3.04,1.75,4.78,3.9,4.78,5.9c0,1.98-1.71,4.1-4.69,5.83 c-3.75,2.18-9.05,3.43-14.54,3.43c-5.49,0-10.81-1.25-14.59-3.43c-3.04-1.75-4.78-3.91-4.79-5.91c0-1.98,1.7-4.1,4.68-5.83 C448.5,2191.69,453.8,2190.44,459.29,2190.44z",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M335.12,2119.81c5.91,0,11.62,1.34,15.68,3.69c3.26,1.88,5.13,4.19,5.14,6.34c0,2.12-1.83,4.41-5.03,6.27 c-4.03,2.34-9.72,3.68-15.62,3.68c-5.9,0-11.61-1.34-15.67-3.68c-3.26-1.88-5.14-4.2-5.14-6.35c0-2.12,1.83-4.41,5.03-6.26 C323.53,2121.15,329.22,2119.81,335.12,2119.81z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M799.25,2044.06c14.11,8.14,14.19,21.34,0.17,29.48c-14.01,8.14-36.82,8.14-50.93,0 c-14.11-8.14-14.17-21.34-0.16-29.48C762.35,2035.92,785.14,2035.92,799.25,2044.06z",
    className: "colorffffff svgShape"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#dbe3e4",
    d: "M774,2081.56c-9.57,0-19.16-2.11-26.48-6.34c-7.47-4.31-11.59-10.16-11.6-16.47 c-0.01-6.27,4.05-12.09,11.43-16.38c14.54-8.44,38.25-8.44,52.87,0l0,0c7.48,4.31,11.6,10.17,11.6,16.48 c0.02,6.27-4.04,12.09-11.42,16.38C793.14,2079.45,783.57,2081.56,774,2081.56z M773.76,2039.89c-8.86,0-17.72,1.95-24.44,5.86 c-6.13,3.56-9.5,8.18-9.5,13c0.01,4.86,3.43,9.51,9.65,13.1c13.56,7.82,35.53,7.82,48.97,0c6.13-3.56,9.5-8.17,9.49-13 c-0.01-4.87-3.43-9.52-9.66-13.11l0,0C791.5,2041.84,782.62,2039.89,773.76,2039.89z",
    className: "colordbdee4 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#21929b",
    d: "M773.96,2068.1c-5.5,0-10.82-1.25-14.6-3.43c-3.04-1.75-4.78-3.9-4.78-5.9c0-1.98,1.71-4.1,4.69-5.83 c3.75-2.18,9.05-3.43,14.54-3.43c5.49,0,10.81,1.25,14.59,3.43c3.04,1.75,4.78,3.91,4.79,5.91c0,1.98-1.7,4.1-4.68,5.83 C784.75,2066.85,779.45,2068.1,773.96,2068.1z",
    className: "color1fb6ff svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M898.13,2138.74c-5.91,0-11.62-1.34-15.68-3.69c-3.26-1.88-5.13-4.19-5.14-6.34c0-2.12,1.83-4.41,5.03-6.27 c4.03-2.34,9.72-3.68,15.62-3.68c5.9,0,11.61,1.34,15.67,3.68c3.26,1.88,5.14,4.2,5.14,6.35c0,2.12-1.83,4.41-5.03,6.26 C909.72,2137.4,904.03,2138.74,898.13,2138.74z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M962.9,1518.7c-5.91,0-11.62-1.34-15.68-3.69c-3.26-1.88-5.13-4.19-5.14-6.34c0-2.12,1.83-4.41,5.03-6.27 c4.03-2.34,9.72-3.68,15.62-3.68c5.9,0,11.61,1.34,15.67,3.68c3.26,1.88,5.14,4.2,5.14,6.35c0,2.12-1.83,4.41-5.03,6.26 C974.48,1517.35,968.79,1518.7,962.9,1518.7z",
    className: "color373b42 svgShape"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1248.17,1787.69c-14.98,0-28.17-5.13-38.23-14.89c-13.71-13.3-20.99-34.23-21.08-60.52 c-0.24-66.41,46.65-147.62,104.53-181.03c28.54-16.49,55.47-19.1,75.83-7.38c20.18,11.62,31.34,35.91,31.42,68.4v0 c0,46.76-22.53,101.39-58.81,142.57c-0.14,0.16-0.31,0.3-0.49,0.41l-6.01,3.43l-84.44,48.73c-0.28,0.16-0.6,0.26-0.92,0.26 C1249.36,1787.68,1248.77,1787.69,1248.17,1787.69z M1341.07,1520.54c-13.99,0-29.56,4.72-45.74,14.07 c-56.79,32.8-102.81,112.49-102.58,177.65c0.08,25.23,6.97,45.19,19.9,57.74c9.58,9.3,22.45,14.09,36.71,13.78l89.75-51.76 c35.55-40.47,57.62-93.99,57.62-139.75c-0.08-31.04-10.54-54.13-29.47-65.03C1359.49,1522.77,1350.65,1520.54,1341.07,1520.54z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1922.3,1372.74c-14.98,0-28.17-5.13-38.23-14.89c-13.71-13.3-20.99-34.23-21.08-60.52 c-0.23-66.41,46.66-147.62,104.53-181.03c28.55-16.49,55.47-19.11,75.84-7.37c20.18,11.62,31.33,35.91,31.41,68.39v0 c0,46.77-22.53,101.4-58.81,142.58c-0.14,0.16-0.31,0.3-0.49,0.41l-6.01,3.43l-84.44,48.73c-0.28,0.16-0.6,0.26-0.92,0.26 C1923.49,1372.73,1922.9,1372.74,1922.3,1372.74z M2015.2,1105.6c-13.98,0-29.55,4.72-45.74,14.07 c-56.78,32.79-102.8,112.48-102.58,177.65c0.08,25.23,6.97,45.19,19.9,57.74c9.31,9.04,21.57,13.79,35.52,13.79 c0.4,0,0.79,0,1.19-0.01l89.75-51.76c35.54-40.47,57.62-93.99,57.62-139.76c-0.07-31.04-10.53-54.13-29.46-65.03 C2033.64,1107.82,2024.8,1105.6,2015.2,1105.6z",
    className: "color373b42 svgShape"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#000000",
    className: "color000000 svgShape"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#374142",
    d: "M1669.84,606.79c-14.98,0-28.17-5.13-38.23-14.89c-13.71-13.3-20.99-34.23-21.08-60.52 c-0.24-66.41,46.65-147.62,104.53-181.03c28.54-16.49,55.46-19.1,75.83-7.38c20.18,11.62,31.34,35.91,31.42,68.4v0 c0,46.77-22.54,101.4-58.82,142.58c-0.14,0.16-0.3,0.3-0.49,0.4l-6,3.43l-84.44,48.73c-0.28,0.16-0.6,0.26-0.92,0.26 C1671.03,606.78,1670.43,606.79,1669.84,606.79z M1762.74,339.64c-13.99,0-29.55,4.72-45.74,14.07 c-56.79,32.8-102.81,112.49-102.58,177.65c0.08,25.23,6.97,45.19,19.9,57.74c9.58,9.3,22.33,14.07,36.71,13.78l89.74-51.76 c35.55-40.46,57.63-93.99,57.63-139.75c-0.08-31.04-10.54-54.13-29.47-65.03C1781.17,341.87,1772.33,339.64,1762.74,339.64z",
    className: "color373b42 svgShape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockchainDevelopment);
export default __webpack_public_path__ + "static/media/blockchain-development.80cb4d6c67df69a81bca7250b3ad716a.svg";
export { ForwardRef as ReactComponent };